export const listSVGIcon03 = {
  partner: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 6H17V4C17 2.89 16.11 2 15 2H9C7.89 2 7 2.89 7 4V6H4C2.89 6 2 6.89 2 8V19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM9 4H15V6H9V4ZM20 19H4V17H20V19ZM20 14H4V8H7V10H9V8H15V10H17V8H20V14Z"
        fill="rgba(0, 0, 0, 0.5)"
      />
    </svg>
  ),
  exportStatistic: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 9H15V3H9V9H5L12 16L19 9ZM11 11V5H13V11H14.17L12 13.17L9.83 11H11ZM5 18H19V20H5V18Z"
        fill="white"
      />
    </svg>
  ),
  editTypeConfig: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7167 7.51667L12.4833 8.28333L4.93333 15.8333H4.16667V15.0667L11.7167 7.51667ZM14.7167 2.5C14.5083 2.5 14.2917 2.58333 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C15.1417 2.575 14.9333 2.5 14.7167 2.5ZM11.7167 5.15833L2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833Z"
        fill="#0D99FF"
      />
    </svg>
  ),
  configTypeProfile: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4308 12.98C19.4708 12.66 19.5008 12.34 19.5008 12C19.5008 11.66 19.4708 11.34 19.4308 11.02L21.5408 9.37C21.7308 9.22 21.7808 8.95 21.6608 8.73L19.6608 5.27C19.5708 5.11 19.4008 5.02 19.2208 5.02C19.1608 5.02 19.1008 5.03 19.0508 5.05L16.5608 6.05C16.0408 5.65 15.4808 5.32 14.8708 5.07L14.4908 2.42C14.4608 2.18 14.2508 2 14.0008 2H10.0008C9.75082 2 9.54082 2.18 9.51082 2.42L9.13082 5.07C8.52082 5.32 7.96082 5.66 7.44082 6.05L4.95082 5.05C4.89082 5.03 4.83082 5.02 4.77082 5.02C4.60082 5.02 4.43082 5.11 4.34082 5.27L2.34082 8.73C2.21082 8.95 2.27082 9.22 2.46082 9.37L4.57082 11.02C4.53082 11.34 4.50082 11.67 4.50082 12C4.50082 12.33 4.53082 12.66 4.57082 12.98L2.46082 14.63C2.27082 14.78 2.22082 15.05 2.34082 15.27L4.34082 18.73C4.43082 18.89 4.60082 18.98 4.78082 18.98C4.84082 18.98 4.90082 18.97 4.95082 18.95L7.44082 17.95C7.96082 18.35 8.52082 18.68 9.13082 18.93L9.51082 21.58C9.54082 21.82 9.75082 22 10.0008 22H14.0008C14.2508 22 14.4608 21.82 14.4908 21.58L14.8708 18.93C15.4808 18.68 16.0408 18.34 16.5608 17.95L19.0508 18.95C19.1108 18.97 19.1708 18.98 19.2308 18.98C19.4008 18.98 19.5708 18.89 19.6608 18.73L21.6608 15.27C21.7808 15.05 21.7308 14.78 21.5408 14.63L19.4308 12.98ZM17.4508 11.27C17.4908 11.58 17.5008 11.79 17.5008 12C17.5008 12.21 17.4808 12.43 17.4508 12.73L17.3108 13.86L18.2008 14.56L19.2808 15.4L18.5808 16.61L17.3108 16.1L16.2708 15.68L15.3708 16.36C14.9408 16.68 14.5308 16.92 14.1208 17.09L13.0608 17.52L12.9008 18.65L12.7008 20H11.3008L11.1108 18.65L10.9508 17.52L9.89082 17.09C9.46082 16.91 9.06082 16.68 8.66082 16.38L7.75082 15.68L6.69082 16.11L5.42082 16.62L4.72082 15.41L5.80082 14.57L6.69082 13.87L6.55082 12.74C6.52082 12.43 6.50082 12.2 6.50082 12C6.50082 11.8 6.52082 11.57 6.55082 11.27L6.69082 10.14L5.80082 9.44L4.72082 8.6L5.42082 7.39L6.69082 7.9L7.73082 8.32L8.63082 7.64C9.06082 7.32 9.47082 7.08 9.88082 6.91L10.9408 6.48L11.1008 5.35L11.3008 4H12.6908L12.8808 5.35L13.0408 6.48L14.1008 6.91C14.5308 7.09 14.9308 7.32 15.3308 7.62L16.2408 8.32L17.3008 7.89L18.5708 7.38L19.2708 8.59L18.2008 9.44L17.3108 10.14L17.4508 11.27ZM12.0008 8C9.79082 8 8.00082 9.79 8.00082 12C8.00082 14.21 9.79082 16 12.0008 16C14.2108 16 16.0008 14.21 16.0008 12C16.0008 9.79 14.2108 8 12.0008 8ZM12.0008 14C10.9008 14 10.0008 13.1 10.0008 12C10.0008 10.9 10.9008 10 12.0008 10C13.1008 10 14.0008 10.9 14.0008 12C14.0008 13.1 13.1008 14 12.0008 14Z"
        fill="#F57C00"
      />
    </svg>
  ),
  config: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4308 12.98C19.4708 12.66 19.5008 12.34 19.5008 12C19.5008 11.66 19.4708 11.34 19.4308 11.02L21.5408 9.37C21.7308 9.22 21.7808 8.95 21.6608 8.73L19.6608 5.27C19.5708 5.11 19.4008 5.02 19.2208 5.02C19.1608 5.02 19.1008 5.03 19.0508 5.05L16.5608 6.05C16.0408 5.65 15.4808 5.32 14.8708 5.07L14.4908 2.42C14.4608 2.18 14.2508 2 14.0008 2H10.0008C9.75082 2 9.54082 2.18 9.51082 2.42L9.13082 5.07C8.52082 5.32 7.96082 5.66 7.44082 6.05L4.95082 5.05C4.89082 5.03 4.83082 5.02 4.77082 5.02C4.60082 5.02 4.43082 5.11 4.34082 5.27L2.34082 8.73C2.21082 8.95 2.27082 9.22 2.46082 9.37L4.57082 11.02C4.53082 11.34 4.50082 11.67 4.50082 12C4.50082 12.33 4.53082 12.66 4.57082 12.98L2.46082 14.63C2.27082 14.78 2.22082 15.05 2.34082 15.27L4.34082 18.73C4.43082 18.89 4.60082 18.98 4.78082 18.98C4.84082 18.98 4.90082 18.97 4.95082 18.95L7.44082 17.95C7.96082 18.35 8.52082 18.68 9.13082 18.93L9.51082 21.58C9.54082 21.82 9.75082 22 10.0008 22H14.0008C14.2508 22 14.4608 21.82 14.4908 21.58L14.8708 18.93C15.4808 18.68 16.0408 18.34 16.5608 17.95L19.0508 18.95C19.1108 18.97 19.1708 18.98 19.2308 18.98C19.4008 18.98 19.5708 18.89 19.6608 18.73L21.6608 15.27C21.7808 15.05 21.7308 14.78 21.5408 14.63L19.4308 12.98ZM17.4508 11.27C17.4908 11.58 17.5008 11.79 17.5008 12C17.5008 12.21 17.4808 12.43 17.4508 12.73L17.3108 13.86L18.2008 14.56L19.2808 15.4L18.5808 16.61L17.3108 16.1L16.2708 15.68L15.3708 16.36C14.9408 16.68 14.5308 16.92 14.1208 17.09L13.0608 17.52L12.9008 18.65L12.7008 20H11.3008L11.1108 18.65L10.9508 17.52L9.89082 17.09C9.46082 16.91 9.06082 16.68 8.66082 16.38L7.75082 15.68L6.69082 16.11L5.42082 16.62L4.72082 15.41L5.80082 14.57L6.69082 13.87L6.55082 12.74C6.52082 12.43 6.50082 12.2 6.50082 12C6.50082 11.8 6.52082 11.57 6.55082 11.27L6.69082 10.14L5.80082 9.44L4.72082 8.6L5.42082 7.39L6.69082 7.9L7.73082 8.32L8.63082 7.64C9.06082 7.32 9.47082 7.08 9.88082 6.91L10.9408 6.48L11.1008 5.35L11.3008 4H12.6908L12.8808 5.35L13.0408 6.48L14.1008 6.91C14.5308 7.09 14.9308 7.32 15.3308 7.62L16.2408 8.32L17.3008 7.89L18.5708 7.38L19.2708 8.59L18.2008 9.44L17.3108 10.14L17.4508 11.27ZM12.0008 8C9.79082 8 8.00082 9.79 8.00082 12C8.00082 14.21 9.79082 16 12.0008 16C14.2108 16 16.0008 14.21 16.0008 12C16.0008 9.79 14.2108 8 12.0008 8ZM12.0008 14C10.9008 14 10.0008 13.1 10.0008 12C10.0008 10.9 10.9008 10 12.0008 10C13.1008 10 14.0008 10.9 14.0008 12C14.0008 13.1 13.1008 14 12.0008 14Z"
        fill="#4d4d4d"
      />
    </svg>
  ),
  searchStatistic: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
        fill="#222D4B"
      />
    </svg>
  ),
  statistic: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 10H9V17H7V10ZM11 7H13V17H11V7ZM15 13H17V17H15V13Z"
        fill="rgba(0, 0, 0, 0.5)"
      />
    </svg>
  ),
  warningInactive: (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M59.9997 93.333C63.6663 93.333 66.6663 90.333 66.6663 86.6663H53.333C53.333 90.333 56.333 93.333 59.9997 93.333ZM79.9997 73.333V56.6663C79.9997 46.433 74.5663 37.8663 64.9997 35.5997V33.333C64.9997 30.5663 62.7663 28.333 59.9997 28.333C57.233 28.333 54.9997 30.5663 54.9997 33.333V35.5997C45.4663 37.8663 39.9997 46.3997 39.9997 56.6663V73.333L33.333 79.9997V83.333H86.6663V79.9997L79.9997 73.333ZM73.333 76.6663H46.6663V56.6663C46.6663 48.3997 51.6997 41.6663 59.9997 41.6663C68.2997 41.6663 73.333 48.3997 73.333 56.6663V76.6663Z"
        fill="#F57C00"
      />
      <circle cx="60" cy="60" r="59.5" stroke="#F57C00" strokeDasharray="5 5" />
    </svg>
  ),
  closeTab: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="white" />
      <path
        d="M14.6668 6.2735L13.7268 5.3335L10.0002 9.06016L6.2735 5.3335L5.3335 6.2735L9.06016 10.0002L5.3335 13.7268L6.2735 14.6668L10.0002 10.9402L13.7268 14.6668L14.6668 13.7268L10.9402 10.0002L14.6668 6.2735Z"
        fill="#323232"
      />
    </svg>
  ),
  defaultAvatar: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#F4F4F4" />
      <path
        d="M20 14C21.1 14 22 14.9 22 16C22 17.1 21.1 18 20 18C18.9 18 18 17.1 18 16C18 14.9 18.9 14 20 14ZM20 23C22.7 23 25.8 24.29 26 25V26H14V25.01C14.2 24.29 17.3 23 20 23ZM20 12C17.79 12 16 13.79 16 16C16 18.21 17.79 20 20 20C22.21 20 24 18.21 24 16C24 13.79 22.21 12 20 12ZM20 21C17.33 21 12 22.34 12 25V28H28V25C28 22.34 22.67 21 20 21Z"
        fill="#626262"
      />
    </svg>
  ),
  bigLogo: (
    <svg
      width="264"
      height="45"
      viewBox="0 0 264 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M28.2558 27.1657C28.186 23.1565 27.8372 20.2532 27.0698 18.2486C26.3023 16.1058 24.7674 14.5159 22.6047 13.6173C20.5814 12.7878 17.6512 12.373 13.7442 12.373C9.69767 12.373 6.76744 12.9952 4.81395 14.3085C2.7907 15.6219 1.46512 17.5574 0.837209 19.9767C0.27907 22.1887 0 25.2993 0 29.3085C0 32.2118 0.209302 34.6311 0.55814 36.4975C0.976744 38.5021 1.67442 40.0919 2.7907 41.3362C3.83721 42.5804 5.37209 43.5482 7.32558 44.1012C9.13953 44.6542 11.5814 44.8615 14.4419 44.8615C17.5116 44.8615 19.9535 44.6542 21.7674 44.2394C23.7907 43.8247 25.3953 42.7878 26.5116 41.1979C27.6977 39.6772 28.2558 37.3961 28.2558 34.3546V33.3178H21.4884V35.3224C21.4884 37.8108 20.5116 38.2256 20.1628 38.433C19.0465 38.986 17.2326 39.1933 14.9302 39.1933H13.7442C11.4419 39.1933 9.76744 38.8477 8.86047 38.1565C7.95349 37.4652 7.39535 36.5666 7.18605 35.4606C6.97674 34.2855 6.83721 32.6265 6.83721 30.4836H28.3256V27.1657H28.2558ZM6.76744 24.9537C6.83721 23.1565 7.04651 21.7048 7.39535 20.7371C7.74419 19.7002 8.37209 19.009 9.34884 18.5942C10.3953 18.1104 12 17.903 14.1628 17.903C16.6047 17.903 18.4186 18.1104 19.4651 18.5942C20.3721 18.9399 20.9302 19.562 21.1395 20.5297C21.4186 21.4975 21.5581 23.0182 21.6279 25.0919H6.76744V24.9537Z"
          fill="#0D99FF"
        />
        <path
          d="M66.2791 30.9677C66.2094 30.1382 66.2094 29.5161 66.2094 29.1014V28.0645H59.3721V29.1014C59.3721 29.5853 59.3721 30.4147 59.4419 31.5207C59.5117 32.6267 59.5117 33.3871 59.5117 33.871C59.4419 35.7373 58.6745 36.9124 57.1396 37.6037C55.3954 38.3641 53.0931 38.7097 50.3721 38.7097C49.8838 38.7097 49.1861 38.7097 48.2791 38.6406C47.3721 38.5714 46.7442 38.5714 46.3954 38.5714C42.2094 38.5714 39.628 37.8111 38.7908 36.4286C37.7442 34.5622 37.2559 30.8295 37.2559 25.2304V15.4147C37.2559 13.2719 37.3954 11.5438 37.7442 10.2995C38.0233 9.19355 38.5815 8.36406 39.4187 7.74194C40.3256 7.11982 41.6512 6.70507 43.4652 6.56682C46.7442 6.35945 49.7442 6.2212 52.3954 6.2212C54.4187 6.2212 55.9535 6.4977 56.8605 7.05069C57.6977 7.53456 58.2559 8.22581 58.4652 9.19355C58.7442 10.3687 58.8838 12.0968 58.8838 14.447V15.4839H65.7907L65.721 14.3779C65.5117 11.3364 65.1628 8.84793 64.7442 7.05069C64.2559 5.18433 63.4187 3.66359 62.2326 2.62673C61.1163 1.58986 59.5117 0.898618 57.628 0.483871C55.8838 0.207373 53.4419 0 50.3721 0C46.5349 0 43.7442 0.138249 41.9303 0.345622C38.9303 0.691244 36.4884 1.52074 34.7442 2.8341C33.0001 4.14747 31.7442 5.9447 31.0466 8.15668C30.4187 10.2304 30.0698 12.7189 30.0698 15.6912V22.4654C30.1396 24.47 30.2094 26.8203 30.2791 29.5853C30.4187 32.4194 30.7675 34.9078 31.4652 36.9816C32.1628 39.1244 33.4884 40.9217 35.3024 42.3733C37.1163 43.7558 39.6977 44.5853 42.907 44.7926H48.9768C51.2791 44.7926 53.5814 44.7235 55.8838 44.5853C62.721 43.9631 66.3489 39.9539 66.3489 33.1106C66.4187 32.5576 66.3489 31.8664 66.2791 30.9677Z"
          fill="#1F2A49"
        />
        <path
          d="M96.1394 18.3874C95.3022 16.1063 93.7673 14.4473 91.6045 13.5487C89.5115 12.6501 86.5115 12.2354 82.5347 12.2354C78.7673 12.2354 75.9766 12.7883 73.9533 13.8252C71.9301 14.9312 70.4649 16.6593 69.7673 19.0095C69.1394 21.1524 68.7905 24.1248 68.7905 27.7883V30.6224C68.7905 34.4934 69.2091 37.3966 70.1161 39.4012C71.0929 41.5441 72.6975 43.0648 74.9301 43.8943C77.0231 44.6547 79.9533 45.0003 83.7905 45.0003C87.9068 45.0003 90.9068 44.3091 92.9301 42.8575C94.9533 41.4059 96.2091 39.4012 96.6277 36.9819C97.0463 34.7699 97.2556 31.5902 97.2556 27.5118C97.2556 23.5026 96.9068 20.5303 96.1394 18.3874ZM90.4184 27.1662C90.4184 30.0695 90.4184 32.3506 90.3487 33.8713C90.2789 35.4612 89.9301 36.7054 89.4417 37.4658C88.9533 38.157 88.2557 38.6409 87.4184 38.8483C86.3719 39.1248 84.9766 39.263 83.1626 39.263H80.9301C78.3487 39.263 77.3022 38.7791 76.8836 38.3644C76.1859 37.604 75.3487 35.5994 75.3487 30.2768V26.8206C75.3487 23.9865 75.558 21.9128 75.9068 20.6685C76.1859 19.6317 76.8138 18.9404 77.7208 18.5948C78.7673 18.1801 80.5812 17.9036 83.1626 17.9036H84.1394C86.8603 17.9036 88.1161 18.3183 88.6743 18.733C89.4417 19.2169 89.9301 19.9773 90.1394 21.0142C90.2789 22.3275 90.4184 24.4012 90.4184 27.1662Z"
          fill="#1F2A49"
        />
        <path
          d="M125.861 17.0741C125.023 15.2769 123.698 13.9635 121.954 13.2032C120.209 12.4428 117.977 12.0972 115.116 12.0972C112.675 12.0972 110.512 12.4428 108.698 13.134C107.651 13.5488 106.744 14.1018 105.907 14.8621V12.7884H99.7676V44.5165H106.326V25.2999C106.326 20.1847 108.837 17.8345 114.14 17.8345C116.093 17.8345 117.489 18.0419 118.395 18.3875C119.163 18.7331 119.651 19.217 119.93 19.9774C120.279 20.876 120.419 22.3276 120.419 24.1939V44.5165H127.047V23.8483C127.047 21.0142 126.628 18.7331 125.861 17.0741Z"
          fill="#1F2A49"
        />
        <path
          d="M146.163 32.0044V34.9076C146.163 36.9813 145.814 37.9491 145.535 38.3638C145.256 38.8477 144.279 39.1242 142.884 39.1242C141 39.1242 140.442 38.7094 140.302 38.5021C140.093 38.2256 139.744 37.5343 139.744 35.5297V18.456H151.256V12.7878H139.744V5.66797H133.116V12.7878H129.209V18.456H133.116V35.5297C133.116 37.8108 133.396 39.6081 134.023 40.9214C134.651 42.373 135.768 43.4099 137.302 44.032C138.698 44.585 140.512 44.8615 142.884 44.8615C146.721 44.8615 149.372 43.8246 150.628 41.6818C151.814 39.6772 152.442 36.9122 152.442 33.0412V32.0044H146.163Z"
          fill="#1F2A49"
        />
        <path
          d="M168.349 12.0972C165.488 12.0972 163.116 12.8575 161.302 14.3783V12.7884H154.884V44.5165H161.442V23.7101C161.442 19.7009 163.326 17.8345 167.372 17.8345C169.116 17.8345 170.233 18.2492 170.721 19.0096C171.279 19.9774 171.628 21.4981 171.628 23.5718V24.6087H178.047V23.5718C178.047 14.1018 172.744 12.0972 168.349 12.0972Z"
          fill="#1F2A49"
        />
        <path
          d="M206.512 16.9353C205.395 15.2072 203.791 14.0321 201.698 13.4791C199.814 12.9952 197.233 12.7188 194.093 12.7188C189.768 12.7188 186.698 13.2717 184.605 14.3777C182.372 15.622 181.186 18.3178 181.186 22.3962V23.433H187.884V22.3962C187.884 22.1197 187.814 21.9123 187.744 21.6358C187.675 21.4284 187.675 21.3593 187.675 21.3593C187.675 20.1842 187.954 19.3547 188.581 18.9399C189.14 18.5252 190.465 17.9722 193.674 17.9722C196.116 17.9722 197.93 18.1105 198.977 18.4561C199.814 18.7326 200.372 19.2164 200.721 20.1151C201.14 21.1519 201.279 22.8109 201.279 25.1611V26.1289C200.581 25.645 199.744 25.2994 198.837 25.092C197.233 24.7464 195.209 24.539 192.768 24.539C190.116 24.539 187.954 24.7464 186.209 25.2303C184.326 25.7141 182.791 26.751 181.744 28.2026C180.698 29.6542 180.14 31.7971 180.14 34.4929C180.14 37.3271 180.628 39.4699 181.675 40.9906C182.721 42.5805 184.186 43.6174 186.14 44.1704C187.884 44.6542 190.186 44.9307 192.977 44.9307C195.488 44.9307 197.581 44.6542 199.256 44.1704C200.163 43.8939 201 43.4791 201.768 42.9261L201.628 44.3777H208.047V24.1934C208.116 20.9446 207.558 18.5943 206.512 16.9353ZM201.698 34.7694C201.698 36.2211 201.349 37.1888 200.581 37.8109C199.744 38.5022 198.768 38.9169 197.581 39.0552C196.326 39.2625 194.651 39.3317 192.768 39.3317C189.907 39.3317 188.651 38.7787 188.093 38.2948C187.326 37.6727 186.977 36.2211 186.977 34.0782C186.977 32.0045 187.465 31.3823 187.605 31.2441L187.675 31.175C188.093 30.7602 189.419 30.1381 193.326 30.1381H194.442C197.023 30.1381 198.977 30.4146 200.233 31.0367C201.209 31.5206 201.698 32.7648 201.698 34.7694Z"
          fill="#1F2A49"
        />
        <path
          d="M232.047 31.5894V32.6262C232.047 34.7691 231.837 36.2898 231.419 37.1884C231.07 37.9488 230.512 38.4327 229.605 38.7092C228.558 38.9857 226.884 39.1239 224.581 39.1239C222.279 39.1239 220.605 38.8474 219.628 38.2253C218.721 37.6723 218.163 36.9119 217.884 35.8059C217.605 34.5617 217.465 32.6262 217.465 30.1377V27.1654C217.465 24.3313 217.674 22.2576 218.023 20.9442C218.372 19.9073 218.93 19.147 219.907 18.8013C221.023 18.3175 222.837 18.1101 225.419 18.1101C227.093 18.1101 228.419 18.2483 229.326 18.594C230.093 18.8705 230.581 19.2852 230.93 19.9765C231.349 20.7368 231.488 21.9119 231.488 23.5709V24.6078H237.907V22.6032C237.907 18.594 236.651 15.8981 234.279 14.4465C232.047 13.1331 228.907 12.4419 224.86 12.4419C221.163 12.4419 218.372 12.9258 216.279 14.0318C214.116 15.1377 212.651 16.7967 211.814 19.0778C211.047 21.2207 210.628 24.1239 210.628 27.7184C210.628 31.0364 210.767 33.6631 210.977 35.4603C211.186 37.3958 211.814 39.1239 212.721 40.5064C213.698 41.958 215.163 43.064 217.186 43.7553C219.07 44.4465 221.581 44.723 224.86 44.723C228.209 44.723 230.721 44.4465 232.605 43.8244C234.628 43.1331 236.163 41.8889 237.14 40.0917C238.047 38.3636 238.535 35.9442 238.535 32.6953V31.6585H232.047V31.5894Z"
          fill="#1F2A49"
        />
        <path
          d="M257.721 32.0044V34.9076C257.721 36.9813 257.372 37.9491 257.093 38.3638C256.814 38.8477 255.837 39.1242 254.442 39.1242C252.558 39.1242 252 38.7094 251.861 38.5021C251.651 38.2256 251.302 37.5343 251.302 35.5297V18.456H262.814V12.7878H251.302V5.66797H244.675V12.7878H240.768V18.456H244.675V35.5297C244.675 37.8108 244.954 39.6081 245.582 40.9214C246.209 42.373 247.326 43.4099 248.861 44.032C250.256 44.585 252.07 44.8615 254.442 44.8615C258.279 44.8615 260.93 43.8246 262.186 41.6818C263.372 39.6772 264 36.9122 264 33.0412V32.0044H257.721Z"
          fill="#1F2A49"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="264" height="45" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  signMethod: (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M66.6665 40L63.3332 33.3333H36.6665V90H43.3332V66.6667H59.9998L63.3332 73.3333H86.6665V40H66.6665ZM79.9998 66.6667H66.6665L63.3332 60H43.3332V40H59.9998L63.3332 46.6667H79.9998V66.6667Z"
        fill="#0D99FF"
      />
      <circle cx="60" cy="60" r="59.5" stroke="#0D99FF" strokeDasharray="5 5" />
    </svg>
  ),
  trashRed: (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.0003 83.3333C40.0003 87 43.0003 90 46.667 90H73.3337C77.0003 90 80.0003 87 80.0003 83.3333V43.3333H40.0003V83.3333ZM46.667 50H73.3337V83.3333H46.667V50ZM71.667 33.3333L68.3337 30H51.667L48.3337 33.3333H36.667V40H83.3337V33.3333H71.667Z"
        fill="#E50500"
      />
      <circle cx="60" cy="60" r="59.5" stroke="#E50500" strokeDasharray="5 5" />
    </svg>
  ),
  logoutIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 7L9.6 8.4L12.2 11H2V13H12.2L9.6 15.6L11 17L16 12L11 7ZM20 19H12V21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3H12V5H20V19Z"
        fill="#222D4B"
      />
    </svg>
  ),
  updateUnit: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.06 9.02L14.98 9.94L5.92 19H5V18.08L14.06 9.02ZM17.66 3C17.41 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3ZM14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19Z"
        fill="white"
      />
    </svg>
  ),
  warningCKS: (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9148 5.99L20.4156 19H5.41406L12.9148 5.99ZM12.9148 2L1.95752 21H23.8722L12.9148 2ZM13.911 16H11.9187V18H13.911V16ZM13.911 10H11.9187V14H13.911V10Z"
        fill="#F57C00"
      />
    </svg>
  ),
  warningAmber: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5.99L19.53 19H4.47L12 5.99ZM12 2L1 21H23L12 2ZM13 16H11V18H13V16ZM13 10H11V14H13V10Z"
        fill="#E50500"
      />
    </svg>
  ),
  arrowDownTree: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 4.5L8 12L0.5 4.5"
        stroke="#868E96"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  undo: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 16H16C19.866 16 23 12.866 23 9C23 5.134 19.866 2 16 2H9"
        stroke="#219653"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 11L2 16L7 21"
        stroke="#219653"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  refresh: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6V9L16 5L12 1V4C7.58 4 4 7.58 4 12C4 13.57 4.46 15.03 5.24 16.26L6.7 14.8C6.25 13.97 6 13.01 6 12C6 8.69 8.69 6 12 6ZM18.76 7.74L17.3 9.2C17.74 10.04 18 10.99 18 12C18 15.31 15.31 18 12 18V15L8 19L12 23V20C16.42 20 20 16.42 20 12C20 10.43 19.54 8.97 18.76 7.74Z"
        fill="#00C968"
      />
    </svg>
  ),
  'refresh-blue': (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33398 7.99998C1.33398 4.33331 4.33398 1.33331 8.00065 1.33331C10.6007 1.33331 12.8673 2.79998 13.934 4.99998"
        stroke="#448AFF"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6664 8C14.6664 11.6667 11.6664 14.6667 7.99974 14.6667C5.39974 14.6667 3.13307 13.2 2.06641 11"
        stroke="#448AFF"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5333 1.13336L14 5.0667L10 4.53336"
        stroke="#448AFF"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.4668 14.8667L2.00013 10.9333L6.00013 11.4667"
        stroke="#448AFF"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  users: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.992 18.7371L8.2 20.4001C8.704 20.7781 9 21.3701 9 22.0001V23.0001H1V22.0001C1 21.3701 1.296 20.7781 1.8 20.4001L4.008 18.7371"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 19C3.895 19 3 18.105 3 17V16C3 14.895 3.895 14 5 14C6.105 14 7 14.895 7 16V17C7 18.105 6.105 19 5 19Z"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.992 5.73706L15.2 7.40006C15.704 7.77806 16 8.37006 16 9.00006V10.0001H8V9.00006C8 8.37006 8.296 7.77806 8.8 7.40006L11.008 5.73706"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6C10.895 6 10 5.105 10 4V3C10 1.895 10.895 1 12 1C13.105 1 14 1.895 14 3V4C14 5.105 13.105 6 12 6Z"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.992 18.7371L22.2 20.4001C22.704 20.7781 23 21.3701 23 22.0001V23.0001H15V22.0001C15 21.3701 15.296 20.7781 15.8 20.4001L18.008 18.7371"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 19C17.895 19 17 18.105 17 17V16C17 14.895 17.895 14 19 14C20.105 14 21 14.895 21 16V17C21 18.105 20.105 19 19 19Z"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  restore: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6C12.5523 6 13 6.44772 13 7V11.5858L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12V7C11 6.44772 11.4477 6 12 6Z"
        fill="#24B8CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.20019 7.06373C3.96759 3.41846 7.71737 1 12 1C18.0523 1 23 5.94772 23 12C23 18.0523 18.0523 23 12 23C5.94772 23 1 18.0523 1 12C1 11.4477 1.44772 11 2 11C2.55228 11 3 11.4477 3 12C3 16.9477 7.05228 21 12 21C16.9477 21 21 16.9477 21 12C21 7.05228 16.9477 3 12 3C8.48263 3 5.43241 4.98154 3.99981 7.93627C3.75887 8.43323 3.16068 8.64076 2.66373 8.39981C2.16677 8.15887 1.95924 7.56068 2.20019 7.06373Z"
        fill="#24B8CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.09664 1.58406C2.64116 1.49172 3.15742 1.85828 3.24976 2.4028L3.91857 6.34687L7.86264 5.67806C8.40716 5.58572 8.92342 5.95228 9.01576 6.4968C9.10809 7.04131 8.74153 7.55757 8.19702 7.64991L3.26702 8.48591C3.00554 8.53025 2.73715 8.4689 2.5209 8.31536C2.30465 8.16181 2.15825 7.92865 2.11391 7.66717L1.27791 2.73717C1.18557 2.19266 1.55213 1.67639 2.09664 1.58406Z"
        fill="#24B8CC"
      />
    </svg>
  ),
  back: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2C8 1.44772 8.44772 1 9 1H16C20.4183 1 24 4.58172 24 9C24 13.4183 20.4183 17 16 17H2C1.44772 17 1 16.5523 1 16C1 15.4477 1.44772 15 2 15H16C19.3137 15 22 12.3137 22 9C22 5.68628 19.3137 3 16 3H9C8.44772 3 8 2.55228 8 2Z"
        fill="#219653"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.70711 10.2929C8.09763 10.6834 8.09763 11.3166 7.70711 11.7071L3.41421 16L7.70711 20.2929C8.09763 20.6834 8.09763 21.3166 7.70711 21.7071C7.31658 22.0976 6.68342 22.0976 6.29289 21.7071L1.29289 16.7071C0.902369 16.3166 0.902369 15.6834 1.29289 15.2929L6.29289 10.2929C6.68342 9.90237 7.31658 9.90237 7.70711 10.2929Z"
        fill="#219653"
      />
    </svg>
  ),
  remove: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4142 12.0002L17.7072 7.70725C18.0982 7.31625 18.0982 6.68425 17.7072 6.29325C17.3162 5.90225 16.6842 5.90225 16.2933 6.29325L12.0002 10.5862L7.70725 6.29325C7.31625 5.90225 6.68425 5.90225 6.29325 6.29325C5.90225 6.68425 5.90225 7.31625 6.29325 7.70725L10.5862 12.0002L6.29325 16.2933C5.90225 16.6842 5.90225 17.3162 6.29325 17.7072C6.48825 17.9022 6.74425 18.0002 7.00025 18.0002C7.25625 18.0002 7.51225 17.9022 7.70725 17.7072L12.0002 13.4142L16.2933 17.7072C16.4882 17.9022 16.7443 18.0002 17.0002 18.0002C17.2562 18.0002 17.5122 17.9022 17.7072 17.7072C18.0982 17.3162 18.0982 16.6842 17.7072 16.2933L13.4142 12.0002Z"
        fill="#616161"
      />
      <mask
        id="mask0"
        {...{ 'mask-type': 'alpha' }} // ✅ truyền trực tiếp attribute gốc SVG
        maskUnits="userSpaceOnUse"
        x="6"
        y="6"
        width="13"
        height="13"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.4142 12.0002L17.7072 7.70725C18.0982 7.31625 18.0982 6.68425 17.7072 6.29325C17.3162 5.90225 16.6842 5.90225 16.2933 6.29325L12.0002 10.5862L7.70725 6.29325C7.31625 5.90225 6.68425 5.90225 6.29325 6.29325C5.90225 6.68425 5.90225 7.31625 6.29325 7.70725L10.5862 12.0002L6.29325 16.2933C5.90225 16.6842 5.90225 17.3162 6.29325 17.7072C6.48825 17.9022 6.74425 18.0002 7.00025 18.0002C7.25625 18.0002 7.51225 17.9022 7.70725 17.7072L12.0002 13.4142L16.2933 17.7072C16.4882 17.9022 16.7443 18.0002 17.0002 18.0002C17.2562 18.0002 17.5122 17.9022 17.7072 17.7072C18.0982 17.3162 18.0982 16.6842 17.7072 16.2933L13.4142 12.0002Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)" />
    </svg>
  ),
  'filter-main': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00018 6H17.0002L11.9902 12.3L7.00018 6ZM4.25018 5.61C6.27018 8.2 10.0002 13 10.0002 13V19C10.0002 19.55 10.4502 20 11.0002 20H13.0002C13.5502 20 14.0002 19.55 14.0002 19V13C14.0002 13 17.7202 8.2 19.7402 5.61C20.2502 4.95 19.7802 4 18.9502 4H5.04018C4.21018 4 3.74018 4.95 4.25018 5.61Z"
        fill="#0D99FF"
      />
    </svg>
  ),
  'filter-white1': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.99969 6H16.9997L11.9897 12.3L6.99969 6ZM4.24969 5.61C6.26969 8.2 9.99969 13 9.99969 13V19C9.99969 19.55 10.4497 20 10.9997 20H12.9997C13.5497 20 13.9997 19.55 13.9997 19V13C13.9997 13 17.7197 8.2 19.7397 5.61C20.2497 4.95 19.7797 4 18.9497 4H5.03969C4.20969 4 3.73969 4.95 4.24969 5.61Z"
        fill="white"
      />
    </svg>
  ),
  'box-confirm': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7071 16.2929C23.0976 16.6834 23.0976 17.3166 22.7071 17.7071L17.7071 22.7071C17.3166 23.0976 16.6834 23.0976 16.2929 22.7071L14.2929 20.7071C13.9024 20.3166 13.9024 19.6834 14.2929 19.2929C14.6834 18.9024 15.3166 18.9024 15.7071 19.2929L17 20.5858L21.2929 16.2929C21.6834 15.9024 22.3166 15.9024 22.7071 16.2929Z"
        fill="#27AE60"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2C0 1.44772 0.447715 1 1 1H23C23.5523 1 24 1.44772 24 2V12C24 12.5523 23.5523 13 23 13C22.4477 13 22 12.5523 22 12V3H2V21H10C10.5523 21 11 21.4477 11 22C11 22.5523 10.5523 23 10 23H1C0.447715 23 0 22.5523 0 22V2Z"
        fill="#27AE60"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4933 4.09558C11.8433 4.26069 12.0667 4.61297 12.0667 5.00001V7.39811C13.5323 7.5105 15.0816 7.89853 16.3582 8.84625C17.986 10.0547 19 12.043 19 15C19 15.4438 18.7075 15.8345 18.2816 15.9595C17.8558 16.0845 17.3985 15.9139 17.1586 15.5405C15.9136 13.6021 14.0982 12.8713 12.0667 12.7055V15C12.0667 15.387 11.8433 15.7393 11.4933 15.9044C11.1432 16.0696 10.7293 16.0179 10.4307 15.7717L4.364 10.7717C4.13351 10.5817 4 10.2987 4 10C4 9.70133 4.13351 9.41829 4.364 9.22833L10.4307 4.22833C10.7293 3.98217 11.1432 3.93046 11.4933 4.09558ZM6.57232 10L10.0667 12.88V11.6667C10.0667 11.1144 10.5144 10.6667 11.0667 10.6667C12.8672 10.6667 14.7811 10.9756 16.4404 12.0328C16.1114 11.3266 15.6632 10.8211 15.1661 10.4521C14.0907 9.65379 12.6097 9.36084 11.0667 9.36084C10.5144 9.36084 10.0667 8.91313 10.0667 8.36084V7.12005L6.57232 10Z"
        fill="#27AE60"
      />
    </svg>
  ),
  'check-list': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 6C11 5.44772 11.4477 5 12 5H23C23.5523 5 24 5.44772 24 6C24 6.55228 23.5523 7 23 7H12C11.4477 7 11 6.55228 11 6Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 3C1 2.44772 1.44772 2 2 2H8C8.55228 2 9 2.44772 9 3V9C9 9.55228 8.55228 10 8 10H2C1.44772 10 1 9.55228 1 9V3ZM3 4V8H7V4H3Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 18C11 17.4477 11.4477 17 12 17H23C23.5523 17 24 17.4477 24 18C24 18.5523 23.5523 19 23 19H12C11.4477 19 11 18.5523 11 18Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7071 13.2929C11.0976 13.6834 11.0976 14.3166 10.7071 14.7071L4.70711 20.7071C4.31658 21.0976 3.68342 21.0976 3.29289 20.7071L1.29289 18.7071C0.902369 18.3166 0.902369 17.6834 1.29289 17.2929C1.68342 16.9024 2.31658 16.9024 2.70711 17.2929L4 18.5858L9.29289 13.2929C9.68342 12.9024 10.3166 12.9024 10.7071 13.2929Z"
          fill="#EB5757"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  'handout-2': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5 9C5.67157 9 5 9.67157 5 10.5C5 11.3284 5.67157 12 6.5 12C7.32843 12 8 11.3284 8 10.5C8 9.67157 7.32843 9 6.5 9ZM3 10.5C3 8.567 4.567 7 6.5 7C8.433 7 10 8.567 10 10.5C10 12.433 8.433 14 6.5 14C4.567 14 3 12.433 3 10.5Z"
          fill="#27AE60"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 12C24 11.4477 23.5523 11 23 11H22C21.3492 11 20.2719 11.124 19.1976 11.4598C18.2997 11.7404 17.2686 12.2106 16.5281 13H14C12.3643 13 10.912 13.7856 9.99972 15H5C3.32232 15 2.2698 15.6124 1.66114 16.3773C1.37282 16.7397 1.21171 17.1021 1.12193 17.3773C1.07682 17.5156 1.04873 17.6348 1.03132 17.7254C1.02259 17.7709 1.01646 17.8096 1.01219 17.8404C1.01006 17.8558 1.00838 17.8693 1.00707 17.8808L1.00537 17.8964L1.00471 17.903L1.00442 17.9061L1.00429 17.9075C1.00422 17.9082 1.00416 17.9089 2 18L1.00416 17.9089C0.963396 18.3544 1.22348 18.7728 1.64102 18.9333L13.4057 23.4582C13.4058 23.4583 13.4056 23.4582 13.4057 23.4582C14.4555 23.8623 15.6264 23.8048 16.6312 23.3024L23.4472 19.8944C23.786 19.725 24 19.3788 24 19V12ZM3.3817 17.46C3.63075 17.2423 4.09907 17 5 17H9.10003C9.03444 17.3231 9 17.6575 9 18C9 18.5523 9.44771 19 10 19H17C17.5523 19 18 18.5523 18 18C18 17.4477 17.5523 17 17 17H11.1707C11.5826 15.8349 12.6939 15 14 15H17C17.3262 15 17.6319 14.8409 17.8191 14.5737C18.1762 14.0637 18.893 13.6504 19.7942 13.3687C20.6701 13.095 21.5458 13 22 13V18.382L15.7368 21.5136C15.2337 21.7651 14.6484 21.7936 14.1243 21.5918L3.3817 17.46Z"
          fill="#27AE60"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.7071 0.292893C21.0976 0.683417 21.0976 1.31658 20.7071 1.70711L14.7071 7.70711C14.3166 8.09763 13.6834 8.09763 13.2929 7.70711L11.2929 5.70711C10.9024 5.31658 10.9024 4.68342 11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289L14 5.58579L19.2929 0.292893C19.6834 -0.0976311 20.3166 -0.0976311 20.7071 0.292893Z"
          fill="#27AE60"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  cheque: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 11C0 10.4477 0.447715 10 1 10H6C6.55228 10 7 10.4477 7 11C7 11.5523 6.55228 12 6 12H2V21H22V12H17C16.4477 12 16 11.5523 16 11C16 10.4477 16.4477 10 17 10H23C23.5523 10 24 10.4477 24 11V22C24 22.5523 23.5523 23 23 23H1C0.447715 23 0 22.5523 0 22V11Z"
        fill="#24B8CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2929 1.29289C14.6834 0.902369 15.3166 0.902369 15.7071 1.29289L18.7071 4.29289C19.0976 4.68342 19.0976 5.31658 18.7071 5.70711L9.70711 14.7071C9.51957 14.8946 9.26522 15 9 15H6C5.44772 15 5 14.5523 5 14V11C5 10.7348 5.10536 10.4804 5.29289 10.2929L14.2929 1.29289ZM7 11.4142V13H8.58579L16.5858 5L15 3.41421L7 11.4142Z"
        fill="#24B8CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 18C5 17.4477 5.44772 17 6 17H18C18.5523 17 19 17.4477 19 18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18Z"
        fill="#24B8CC"
      />
    </svg>
  ),
  'curved-previous': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3827 2.07615C10.7564 2.23093 11 2.59557 11 3.00003V7.02266C13.6775 7.14467 16.6994 7.78362 19.1713 9.50429C22.0179 11.4858 24 14.8085 24 20C24 20.4513 23.6978 20.8467 23.2623 20.965C22.8268 21.0834 22.366 20.8954 22.1376 20.5062C20.8447 18.3035 19.6007 16.9885 17.8759 16.1806C16.2711 15.429 14.1535 15.0694 11 15.0092V19C11 19.4045 10.7564 19.7691 10.3827 19.9239C10.009 20.0787 9.57889 19.9931 9.29289 19.7071L1.29289 11.7071C0.902369 11.3166 0.902369 10.6834 1.29289 10.2929L9.29289 2.29292C9.57889 2.00692 10.009 1.92137 10.3827 2.07615ZM3.41421 11L9 16.5858V14C9 13.4477 9.44772 13 10 13C13.7848 13 16.5429 13.3478 18.7241 14.3694C19.8286 14.8867 20.756 15.5624 21.5819 16.405C20.9399 13.9086 19.6174 12.2516 18.0287 11.1458C15.7141 9.5346 12.6976 9.00003 10 9.00003C9.44772 9.00003 9 8.55231 9 8.00003V5.41424L3.41421 11Z"
        fill="#9B51E0"
      />
    </svg>
  ),
  'g-chart': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 14C1 13.4477 1.44772 13 2 13H6C6.55228 13 7 13.4477 7 14V20C7 20.5523 6.55228 21 6 21H2C1.44772 21 1 20.5523 1 20V14ZM3 15V19H5V15H3Z"
        fill="#27AE60"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 9C9 8.44772 9.44772 8 10 8H14C14.5523 8 15 8.44772 15 9V20C15 20.5523 14.5523 21 14 21H10C9.44772 21 9 20.5523 9 20V9ZM11 10V19H13V10H11Z"
        fill="#27AE60"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 4C17 3.44772 17.4477 3 18 3H22C22.5523 3 23 3.44772 23 4V20C23 20.5523 22.5523 21 22 21H18C17.4477 21 17 20.5523 17 20V4ZM19 5V19H21V5H19Z"
        fill="#27AE60"
      />
    </svg>
  ),
  handout: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 8C16.6716 8 16 8.67157 16 9.5C16 10.3284 16.6716 11 17.5 11C18.3284 11 19 10.3284 19 9.5C19 8.67157 18.3284 8 17.5 8ZM14 9.5C14 7.567 15.567 6 17.5 6C19.433 6 21 7.567 21 9.5C21 11.433 19.433 13 17.5 13C15.567 13 14 11.433 14 9.5Z"
        fill="#F2994A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 2C8.67157 2 8 2.67157 8 3.5C8 4.32843 8.67157 5 9.5 5C10.3284 5 11 4.32843 11 3.5C11 2.67157 10.3284 2 9.5 2ZM6 3.5C6 1.567 7.567 0 9.5 0C11.433 0 13 1.567 13 3.5C13 5.433 11.433 7 9.5 7C7.567 7 6 5.433 6 3.5Z"
        fill="#F2994A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12C0 11.4477 0.447715 11 1 11H2C2.65081 11 3.72806 11.124 4.80242 11.4598C5.70034 11.7404 6.73139 12.2106 7.4719 13H10C11.6357 13 13.088 13.7856 14.0003 15H19C20.6777 15 21.7302 15.6124 22.3389 16.3773C22.6272 16.7397 22.7883 17.1021 22.8781 17.3773C22.9232 17.5156 22.9513 17.6348 22.9687 17.7254C22.9774 17.7709 22.9835 17.8096 22.9878 17.8404C22.9899 17.8558 22.9916 17.8693 22.9929 17.8808L22.9946 17.8964L22.9953 17.903L22.9956 17.9061L22.9957 17.9075C22.9958 17.9082 22.9958 17.9089 22 18L22.9958 17.9089C23.0366 18.3544 22.7765 18.7728 22.359 18.9333L10.5943 23.4582C10.5942 23.4583 10.5944 23.4582 10.5943 23.4582C9.54446 23.8623 8.37357 23.8048 7.36879 23.3024L0.552786 19.8944C0.214002 19.725 0 19.3788 0 19V12ZM20.6183 17.46C20.3693 17.2423 19.9009 17 19 17H14.9C14.9656 17.3231 15 17.6575 15 18C15 18.5523 14.5523 19 14 19H7C6.44772 19 6 18.5523 6 18C6 17.4477 6.44772 17 7 17H12.8293C12.4174 15.8349 11.3061 15 10 15H7C6.67378 15 6.36806 14.8409 6.18092 14.5737C5.82377 14.0637 5.10703 13.6504 4.20583 13.3687C3.32994 13.095 2.45419 13 2 13V18.382L8.26321 21.5136C8.76633 21.7651 9.35162 21.7936 9.8757 21.5918L20.6183 17.46Z"
        fill="#F2994A"
      />
    </svg>
  ),
  'send-message': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7071 2.29289C22.0976 2.68342 22.0976 3.31658 21.7071 3.70711L10.7071 14.7071C10.3166 15.0976 9.68342 15.0976 9.29289 14.7071C8.90237 14.3166 8.90237 13.6834 9.29289 13.2929L20.2929 2.29289C20.6834 1.90237 21.3166 1.90237 21.7071 2.29289Z"
        fill="#2F80ED"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7071 2.29292C21.9829 2.56873 22.0732 2.97973 21.9384 3.34573L14.9384 22.3457C14.8005 22.7199 14.4535 22.9764 14.0553 22.9985C13.6571 23.0206 13.2839 22.8039 13.1056 22.4472L9.25465 14.7454L1.55279 10.8945C1.19611 10.7161 0.979485 10.3429 1.00154 9.94473C1.02359 9.54656 1.28011 9.19955 1.6543 9.06169L20.6543 2.06169C21.0203 1.92684 21.4313 2.01711 21.7071 2.29292ZM4.51462 10.1393L10.4472 13.1056C10.6407 13.2024 10.7977 13.3593 10.8944 13.5528L13.8607 19.4854L19.3126 4.6874L4.51462 10.1393Z"
        fill="#2F80ED"
      />
    </svg>
  ),
  'warning-usb': (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M59.9997 39.966L85.0997 83.3327H34.8997L59.9997 39.966ZM59.9997 26.666L23.333 89.9993H96.6663L59.9997 26.666ZM63.333 73.3327H56.6663V79.9993H63.333V73.3327ZM63.333 53.3327H56.6663V66.666H63.333V53.3327Z"
        fill="#F57C00"
      />
      <circle cx="60" cy="60" r="59.5" stroke="#F57C00" strokeDasharray="5 5" />
    </svg>
  ),
  'warning-usb2': (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
    >
      <path
        d="M56.666 69.9998H63.3327V76.6665H56.666V69.9998ZM56.666 43.3332H63.3327V63.3332H56.666V43.3332ZM59.966 26.6665C41.566 26.6665 26.666 41.5998 26.666 59.9998C26.666 78.3998 41.566 93.3332 59.966 93.3332C78.3994 93.3332 93.3327 78.3998 93.3327 59.9998C93.3327 41.5998 78.3994 26.6665 59.966 26.6665ZM59.9994 86.6665C45.266 86.6665 33.3327 74.7332 33.3327 59.9998C33.3327 45.2665 45.266 33.3332 59.9994 33.3332C74.7327 33.3332 86.666 45.2665 86.666 59.9998C86.666 74.7332 74.7327 86.6665 59.9994 86.6665Z"
        fill="#E50500"
      />
      <circle cx="60" cy="60" r="59.5" stroke="#E50500" strokeDasharray="5 5" />
    </svg>
  ),
  'not-cks': (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M56.667 69.9994H63.3337V76.666H56.667V69.9994ZM56.667 43.3327H63.3337V63.3327H56.667V43.3327ZM59.967 26.666C41.567 26.666 26.667 41.5993 26.667 59.9994C26.667 78.3994 41.567 93.3327 59.967 93.3327C78.4003 93.3327 93.3337 78.3994 93.3337 59.9994C93.3337 41.5993 78.4003 26.666 59.967 26.666ZM60.0003 86.666C45.267 86.666 33.3337 74.7327 33.3337 59.9994C33.3337 45.266 45.267 33.3327 60.0003 33.3327C74.7337 33.3327 86.667 45.266 86.667 59.9994C86.667 74.7327 74.7337 86.666 60.0003 86.666Z"
        fill="#E50500"
      />
      <circle cx="60" cy="60" r="59.5" stroke="#E50500" strokeDasharray="5 5" />
    </svg>
  ),
  'd-check': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7071 7.29289C19.0976 7.68342 19.0976 8.31658 18.7071 8.70711L10.7071 16.7071C10.3166 17.0976 9.68342 17.0976 9.29289 16.7071L5.29289 12.7071C4.90237 12.3166 4.90237 11.6834 5.29289 11.2929C5.68342 10.9024 6.31658 10.9024 6.70711 11.2929L10 14.5858L17.2929 7.29289C17.6834 6.90237 18.3166 6.90237 18.7071 7.29289Z"
        fill="#868E96"
      />
    </svg>
  ),
  bin: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
        fill={'#E50500'}
      />
    </svg>
  ),
  lock: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 6.875H3.75C3.40482 6.875 3.125 7.15482 3.125 7.5V16.25C3.125 16.5952 3.40482 16.875 3.75 16.875H16.25C16.5952 16.875 16.875 16.5952 16.875 16.25V7.5C16.875 7.15482 16.5952 6.875 16.25 6.875Z"
        stroke="#FEC328"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.1875 6.875V4.0625C7.1875 3.31658 7.48382 2.60121 8.01126 2.07376C8.53871 1.54632 9.25408 1.25 10 1.25C10.7459 1.25 11.4613 1.54632 11.9887 2.07376C12.5162 2.60121 12.8125 3.31658 12.8125 4.0625V6.875"
        stroke="#FEC328"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12.8125C10.5178 12.8125 10.9375 12.3928 10.9375 11.875C10.9375 11.3572 10.5178 10.9375 10 10.9375C9.48223 10.9375 9.0625 11.3572 9.0625 11.875C9.0625 12.3928 9.48223 12.8125 10 12.8125Z"
        fill="#FEC328"
      />
    </svg>
  ),
  hierarchy: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9V15"
        stroke="#1574F6"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 15V12H21V15"
        stroke="#1574F6"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 23C4.10457 23 5 22.1046 5 21C5 19.8954 4.10457 19 3 19C1.89543 19 1 19.8954 1 21C1 22.1046 1.89543 23 3 23Z"
        stroke="#1574F6"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M12 23C13.1046 23 14 22.1046 14 21C14 19.8954 13.1046 19 12 19C10.8954 19 10 19.8954 10 21C10 22.1046 10.8954 23 12 23Z"
        stroke="#1574F6"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M21 23C22.1046 23 23 22.1046 23 21C23 19.8954 22.1046 19 21 19C19.8954 19 19 19.8954 19 21C19 22.1046 19.8954 23 21 23Z"
        stroke="#1574F6"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M14 1H10V5H14V1Z"
        stroke="#1574F6"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  settings: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M14 19L16.95 21.95C17.2759 22.2826 17.6648 22.5468 18.0941 22.7272C18.5234 22.9076 18.9844 23.0005 19.45 23.0005C19.9156 23.0005 20.3766 22.9076 20.8059 22.7272C21.2352 22.5468 21.6241 22.2826 21.95 21.95V21.95C22.2826 21.6241 22.5468 21.2352 22.7272 20.8059C22.9076 20.3766 23.0005 19.9156 23.0005 19.45C23.0005 18.9844 22.9076 18.5234 22.7272 18.0941C22.5468 17.6648 22.2826 17.2759 21.95 16.95L20 15"
          stroke="#F2994A"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.925 10.225L6.5 6.79999"
          stroke="#F2994A"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.4001 7.49999L6.5001 6.79999L7.2001 4.69999L4.4001 1.89999L1.6001 4.69999L4.4001 7.49999Z"
          stroke="#F2994A"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.6781 4.92199L19.6001 7.98699L16.0051 4.41098L19.0851 1.34499C18.3746 1.03694 17.593 0.930716 16.8261 1.03799C15.4031 1.16021 14.0802 1.82008 13.1266 2.8833C12.173 3.94651 11.6604 5.33315 11.6931 6.76099C11.6855 7.32229 11.7899 7.87946 12.0001 8.39998L2.14506 17.083C1.80331 17.3877 1.52625 17.758 1.33032 18.1718C1.13438 18.5856 1.02357 19.0346 1.00445 19.4921C0.985327 19.9496 1.05829 20.4062 1.21901 20.835C1.37973 21.2637 1.62493 21.6558 1.94006 21.988V21.988C2.26247 22.3252 2.65296 22.5899 3.08559 22.7646C3.51822 22.9392 3.98307 23.0197 4.44923 23.0008C4.91538 22.9819 5.37218 22.864 5.78923 22.6548C6.20628 22.4457 6.57405 22.1502 6.86806 21.788L15.5941 11.978C16.5267 12.2515 17.5075 12.3198 18.4691 12.178C19.4823 11.9687 20.4192 11.4869 21.1789 10.7845C21.9385 10.0821 22.4921 9.18573 22.7801 8.19199C23.1074 7.12053 23.0715 5.97096 22.6781 4.92199V4.92199Z"
          stroke="#F2994A"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.6723 4.9334C22.9946 5.64627 23.1056 6.43052 22.9933 7.19995C22.8651 8.62761 22.1742 9.95481 21.0612 10.9114"
          stroke="#F2994A"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  database: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 4V20C3 21.7 7 23 12 23C17 23 21 21.7 21 20V4"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M12 7C16.9706 7 21 5.65685 21 4C21 2.34315 16.9706 1 12 1C7.02944 1 3 2.34315 3 4C3 5.65685 7.02944 7 12 7Z"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M21 12C21 13.7 17 15 12 15C7 15 3 13.7 3 12"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  ),
  chart: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 20H14V4H10V20ZM4 20H8V12H4V20ZM16 9V20H20V9H16Z"
        fill="#222"
        fillOpacity="none"
      />
    </svg>
  ),
  notes: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 4C1 3.44772 1.44772 3 2 3H4C4.55228 3 5 3.44772 5 4C5 4.55228 4.55228 5 4 5H3V22H21V5H20C19.4477 5 19 4.55228 19 4C19 3.44772 19.4477 3 20 3H22C22.5523 3 23 3.44772 23 4V23C23 23.5523 22.5523 24 22 24H2C1.44772 24 1 23.5523 1 23V4Z"
        fill="#868E96"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.1706 2C9.58229 0.834621 10.6934 0 12 0C13.3066 0 14.4177 0.834621 14.8294 2H17C17.5523 2 18 2.44772 18 3V7C18 7.55228 17.5523 8 17 8H7C6.44772 8 6 7.55228 6 7V3C6 2.44772 6.44772 2 7 2H9.1706ZM12 2C11.4473 2 11 2.44728 11 3C11 3.55228 10.5523 4 10 4H8V6H16V4H14C13.4477 4 13 3.55228 13 3C13 2.44728 12.5527 2 12 2Z"
        fill="#868E96"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 11C6 10.4477 6.44772 10 7 10H17C17.5523 10 18 10.4477 18 11C18 11.5523 17.5523 12 17 12H7C6.44772 12 6 11.5523 6 11Z"
        fill="#868E96"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 15C6 14.4477 6.44772 14 7 14H17C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16H7C6.44772 16 6 15.5523 6 15Z"
        fill="#868E96"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 19C6 18.4477 6.44772 18 7 18H11C11.5523 18 12 18.4477 12 19C12 19.5523 11.5523 20 11 20H7C6.44772 20 6 19.5523 6 19Z"
        fill="#868E96"
      />
    </svg>
  ),
  logoLogin: (
    <svg
      width="162"
      height="111"
      viewBox="0 0 162 111"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M74.443 1.44831C74.7158 0.405756 75.7876 -0.208084 76.8204 0.0647335L112.93 9.61335C113.972 9.88617 114.586 10.958 114.313 11.9908L102.845 55.3785C102.572 56.4211 101.501 57.0349 100.468 56.7621L64.3585 47.2135C63.3159 46.9407 62.7021 45.8689 62.9749 44.8361L74.443 1.44831Z"
        fill="#FF0F0F"
      />
      <path
        d="M47.26 17.1348C47.0164 16.0825 47.6692 15.0399 48.7118 14.7963L85.0745 6.30002C86.1268 6.05643 87.1693 6.70924 87.4129 7.7518L96.7374 47.6514C96.981 48.7037 96.3282 49.7462 95.2856 49.9898L58.9229 58.4861C57.8706 58.7297 56.8281 58.0769 56.5845 57.0344L47.26 17.1348Z"
        fill="#FFC700"
      />
      <path
        d="M48.7592 20.0781C47.6875 20.0781 46.8105 20.955 46.8105 22.0268V27.0155V32.0042V63.9336C46.8105 65.0054 47.6875 65.8823 48.7592 65.8823H113.076C114.148 65.8823 115.025 65.0054 115.025 63.9336V28.9642C115.025 27.8924 114.148 27.0155 113.076 27.0155H78.4866L76.3333 21.335C76.0508 20.575 75.32 20.0781 74.5113 20.0781H48.7592Z"
        fill="url(#paint0_linear_5239_28011)"
      />
      <path
        d="M74.91 45.2164C74.8516 41.7867 74.5495 39.3119 73.8967 37.597C73.2439 35.7652 71.9285 34.4109 70.087 33.6411C68.3624 32.9299 65.8583 32.5791 62.5163 32.5791C59.0574 32.5791 56.5533 33.115 54.8871 34.2355C53.1625 35.3463 52.0226 37.0026 51.4867 39.0683C51.0092 40.9585 50.7754 43.6185 50.7754 47.0384C50.7754 49.523 50.9508 51.5886 51.2528 53.1768C51.6133 54.8917 52.2077 56.246 53.1625 57.3081C54.0589 58.3701 55.3646 59.1983 57.0307 59.666C58.5799 60.1337 60.665 60.3188 63.1106 60.3188C65.7316 60.3188 67.8168 60.1434 69.366 59.7829C71.0906 59.4322 72.4644 58.5455 73.4193 57.1814C74.4326 55.8855 74.91 53.9368 74.91 51.3353V50.4681H69.1321V52.183C69.1321 54.3071 68.2942 54.6676 68.0019 54.843C67.047 55.3107 65.4978 55.4958 63.5296 55.4958H62.5163C60.5481 55.4958 59.1158 55.2035 58.3461 54.6091C57.5666 54.0148 57.0989 53.2548 56.9138 52.3097C56.7384 51.3061 56.6117 49.8835 56.6117 48.0615H74.9685V45.2262H74.91V45.2164ZM56.5533 43.3262C56.6117 41.7867 56.7871 40.5493 57.0892 39.7211C57.3912 38.8344 57.9271 38.2401 58.7553 37.8893C59.6517 37.4801 61.0158 37.295 62.8671 37.295C64.9522 37.295 66.5014 37.4703 67.3978 37.8893C68.1675 38.1816 68.645 38.7175 68.8301 39.5457C69.0639 40.3739 69.1906 41.6698 69.249 43.4431H56.5533V43.3262Z"
        fill="white"
      />
      <path
        d="M81.0984 35.1514H94.2229C94.7587 35.1514 95.1972 35.5898 95.1972 36.1257V38.1426C95.1972 38.6785 94.7587 39.117 94.2229 39.117H81.0984C80.5625 39.117 80.124 38.6785 80.124 38.1426V36.1257C80.124 35.5898 80.5625 35.1514 81.0984 35.1514Z"
        fill="white"
      />
      <path
        d="M81.0984 45.0596H104.337C104.872 45.0596 105.311 45.498 105.311 46.0339V48.0508C105.311 48.5867 104.872 49.0252 104.337 49.0252H81.0984C80.5625 49.0252 80.124 48.5867 80.124 48.0508V46.0339C80.124 45.498 80.5625 45.0596 81.0984 45.0596Z"
        fill="white"
      />
      <path
        d="M81.0984 54.9785H110.085C110.621 54.9785 111.06 55.417 111.06 55.9529V57.9698C111.06 58.5057 110.621 58.9441 110.085 58.9441H81.0984C80.5625 58.9441 80.124 58.5057 80.124 57.9698V55.9529C80.124 55.417 80.5625 54.9785 81.0984 54.9785Z"
        fill="white"
      />
      <path
        d="M17.3389 99.9664C17.296 97.495 17.082 95.7053 16.6111 94.4696C16.1401 93.1487 15.1983 92.1686 13.8711 91.6147C12.6295 91.1033 10.8314 90.8477 8.43396 90.8477C5.95087 90.8477 4.15276 91.2312 2.95403 92.0408C1.71248 92.8504 0.899052 94.0435 0.513744 95.5349C0.171248 96.8984 0 98.8159 0 101.287C0 103.077 0.128436 104.568 0.342496 105.719C0.599368 106.955 1.02749 107.935 1.71248 108.702C2.35466 109.469 3.29652 110.065 4.49526 110.406C5.60837 110.747 7.10679 110.875 8.86208 110.875C10.7458 110.875 12.2442 110.747 13.3573 110.491C14.5989 110.236 15.5836 109.597 16.2686 108.616C16.9964 107.679 17.3389 106.273 17.3389 104.398V103.759H13.1861V104.995C13.1861 106.529 12.5867 106.784 12.3727 106.912C11.6877 107.253 10.5746 107.381 9.16177 107.381H8.43396C7.02117 107.381 5.99368 107.168 5.43712 106.742C4.88057 106.315 4.53807 105.762 4.40964 105.08C4.2812 104.355 4.19558 103.333 4.19558 102.012H17.3817V99.9664H17.3389ZM4.15276 98.6029C4.19558 97.495 4.32401 96.6002 4.53807 96.0036C4.75213 95.3644 5.13744 94.9383 5.73681 94.6827C6.37899 94.3844 7.36366 94.2565 8.69084 94.2565C10.1893 94.2565 11.3024 94.3844 11.9445 94.6827C12.5011 94.8957 12.8436 95.2792 12.972 95.8758C13.1433 96.4723 13.2289 97.4098 13.2717 98.6881H4.15276V98.6029Z"
        fill="#1F2A49"
      />
      <path
        d="M40.6716 102.31C40.6288 101.799 40.6288 101.416 40.6288 101.16V100.521H36.4332V101.16C36.4332 101.458 36.4332 101.97 36.476 102.651C36.5188 103.333 36.5188 103.802 36.5188 104.1C36.476 105.251 36.0051 105.975 35.0632 106.401C33.9929 106.87 32.5801 107.083 30.9104 107.083C30.6108 107.083 30.1826 107.083 29.6261 107.04C29.0695 106.998 28.6842 106.998 28.4702 106.998C25.9014 106.998 24.3174 106.529 23.8036 105.677C23.1615 104.526 22.8618 102.225 22.8618 98.7738V92.723C22.8618 91.402 22.9474 90.3368 23.1615 89.5698C23.3327 88.888 23.6752 88.3766 24.189 87.9931C24.7455 87.6096 25.5589 87.354 26.6721 87.2688C28.6842 87.1409 30.5251 87.0557 32.152 87.0557C33.3935 87.0557 34.3354 87.2261 34.892 87.567C35.4057 87.8653 35.7482 88.2914 35.8766 88.888C36.0479 89.6124 36.1335 90.6776 36.1335 92.1264V92.7656H40.3719L40.3291 92.0838C40.2006 90.2089 39.9866 88.6749 39.7297 87.567C39.43 86.4165 38.9163 85.4791 38.1885 84.8399C37.5035 84.2008 36.5188 83.7746 35.3629 83.519C34.2926 83.3485 32.7942 83.2207 30.9104 83.2207C28.5558 83.2207 26.8433 83.3059 25.7302 83.4338C23.8893 83.6468 22.3909 84.1581 21.3206 84.9678C20.2503 85.7774 19.4796 86.8853 19.0515 88.2488C18.6662 89.5271 18.4521 91.0611 18.4521 92.8934V97.0693C18.495 98.305 18.5378 99.7538 18.5806 101.458C18.6662 103.205 18.8803 104.739 19.3084 106.018C19.7365 107.339 20.5499 108.446 21.663 109.341C22.7762 110.194 24.3602 110.705 26.3296 110.833H30.0542C31.467 110.833 32.8798 110.79 34.2926 110.705C38.4882 110.321 40.7144 107.85 40.7144 103.631C40.7572 103.291 40.7144 102.864 40.6716 102.31Z"
        fill="#1F2A49"
      />
      <path
        d="M58.9942 94.5561C58.4805 93.1499 57.5386 92.1272 56.2114 91.5733C54.9271 91.0193 53.0862 90.7637 50.6459 90.7637C48.334 90.7637 46.6216 91.1046 45.38 91.7437C44.1385 92.4255 43.2394 93.4908 42.8113 94.9396C42.426 96.2605 42.2119 98.0928 42.2119 100.351V102.098C42.2119 104.484 42.4688 106.274 43.0253 107.51C43.6247 108.831 44.6094 109.768 45.9794 110.28C47.2637 110.748 49.0618 110.961 51.4165 110.961C53.9424 110.961 55.7833 110.535 57.0249 109.64C58.2664 108.746 59.037 107.51 59.2939 106.018C59.5508 104.655 59.6792 102.695 59.6792 100.181C59.6792 97.7093 59.4652 95.877 58.9942 94.5561ZM55.4836 99.9677C55.4836 101.757 55.4836 103.164 55.4408 104.101C55.398 105.081 55.184 105.848 54.8843 106.317C54.5846 106.743 54.1565 107.041 53.6427 107.169C53.0005 107.339 52.1443 107.425 51.0312 107.425H49.6612C48.0772 107.425 47.435 107.126 47.1781 106.871C46.75 106.402 46.2362 105.166 46.2362 101.885V99.7546C46.2362 98.0076 46.3647 96.7292 46.5787 95.9622C46.75 95.3231 47.1353 94.8969 47.6919 94.6839C48.334 94.4282 49.4471 94.2578 51.0312 94.2578H51.6306C53.3002 94.2578 54.0708 94.5134 54.4133 94.7691C54.8843 95.0674 55.184 95.5361 55.3124 96.1753C55.398 96.9849 55.4836 98.2632 55.4836 99.9677Z"
        fill="#1F2A49"
      />
      <path
        d="M77.2334 93.7457C76.7196 92.6378 75.9062 91.8282 74.8359 91.3595C73.7656 90.8908 72.3956 90.6777 70.6403 90.6777C69.1419 90.6777 67.8147 90.8908 66.7016 91.3169C66.0594 91.5726 65.5029 91.9135 64.9891 92.3822V91.1038H61.2217V110.662H65.246V98.8165C65.246 95.6632 66.7872 94.2145 70.041 94.2145C71.2397 94.2145 72.0959 94.3423 72.6525 94.5553C73.1234 94.7684 73.4231 95.0667 73.5943 95.5354C73.8084 96.0893 73.894 96.9842 73.894 98.1347V110.662H77.9612V97.9216C77.9612 96.1746 77.7043 94.7684 77.2334 93.7457Z"
        fill="#1F2A49"
      />
      <path
        d="M89.6924 102.95V104.739C89.6924 106.018 89.4783 106.614 89.3071 106.87C89.1358 107.168 88.5364 107.339 87.6802 107.339C86.5243 107.339 86.1818 107.083 86.0962 106.955C85.9677 106.785 85.7537 106.359 85.7537 105.123V94.5979H92.8176V91.1038H85.7537V86.7148H81.6865V91.1038H79.2891V94.5979H81.6865V105.123C81.6865 106.529 81.8578 107.637 82.2431 108.447C82.6284 109.341 83.3134 109.981 84.2553 110.364C85.1115 110.705 86.2246 110.875 87.6802 110.875C90.0349 110.875 91.6617 110.236 92.4323 108.915C93.1601 107.68 93.5454 105.975 93.5454 103.589V102.95H89.6924Z"
        fill="#1F2A49"
      />
      <path
        d="M103.305 90.6777C101.549 90.6777 100.094 91.1465 98.9807 92.0839V91.1038H95.042V110.662H99.0663V97.8364C99.0663 95.365 100.222 94.2145 102.705 94.2145C103.776 94.2145 104.461 94.4701 104.76 94.9388C105.103 95.5354 105.317 96.4728 105.317 97.7512V98.3903H109.256V97.7512C109.256 91.9135 106.002 90.6777 103.305 90.6777Z"
        fill="#1F2A49"
      />
      <path
        d="M126.724 93.6608C126.039 92.5955 125.054 91.8711 123.77 91.5302C122.614 91.232 121.03 91.0615 119.103 91.0615C116.449 91.0615 114.565 91.4024 113.281 92.0842C111.911 92.8512 111.183 94.513 111.183 97.0271V97.6662H115.293V97.0271C115.293 96.8566 115.25 96.7288 115.208 96.5584C115.165 96.4305 115.165 96.3879 115.165 96.3879C115.165 95.6635 115.336 95.1522 115.721 94.8965C116.064 94.6409 116.877 94.3 118.847 94.3C120.345 94.3 121.458 94.3852 122.1 94.5982C122.614 94.7687 122.956 95.067 123.171 95.6209C123.427 96.2601 123.513 97.2827 123.513 98.7315V99.3281C123.085 99.0298 122.571 98.8167 122.015 98.6889C121.03 98.4759 119.788 98.348 118.29 98.348C116.663 98.348 115.336 98.4759 114.266 98.7741C113.11 99.0724 112.168 99.7116 111.526 100.606C110.884 101.501 110.541 102.822 110.541 104.484C110.541 106.231 110.841 107.552 111.483 108.489C112.125 109.47 113.024 110.109 114.223 110.45C115.293 110.748 116.706 110.918 118.418 110.918C119.96 110.918 121.244 110.748 122.271 110.45C122.828 110.279 123.342 110.023 123.813 109.683L123.727 110.577H127.666V98.135C127.709 96.1322 127.366 94.6835 126.724 93.6608ZM123.77 104.654C123.77 105.549 123.556 106.146 123.085 106.529C122.571 106.955 121.972 107.211 121.244 107.296C120.473 107.424 119.446 107.467 118.29 107.467C116.535 107.467 115.764 107.126 115.422 106.828C114.951 106.444 114.737 105.549 114.737 104.228C114.737 102.95 115.036 102.567 115.122 102.481L115.165 102.439C115.422 102.183 116.235 101.8 118.632 101.8H119.317C120.901 101.8 122.1 101.97 122.871 102.353C123.47 102.652 123.77 103.419 123.77 104.654Z"
        fill="#1F2A49"
      />
      <path
        d="M142.393 102.693V103.332C142.393 104.653 142.265 105.59 142.008 106.144C141.794 106.613 141.451 106.911 140.895 107.082C140.253 107.252 139.225 107.338 137.812 107.338C136.4 107.338 135.372 107.167 134.773 106.784C134.216 106.443 133.874 105.974 133.702 105.292C133.531 104.525 133.446 103.332 133.446 101.798V99.9658C133.446 98.2188 133.574 96.9404 133.788 96.1308C134.002 95.4916 134.345 95.0229 134.944 94.8099C135.629 94.5116 136.742 94.3838 138.326 94.3838C139.354 94.3838 140.167 94.469 140.724 94.682C141.195 94.8525 141.494 95.1081 141.708 95.5343C141.965 96.003 142.051 96.7274 142.051 97.75V98.3892H145.989V97.1535C145.989 94.682 145.219 93.0202 143.763 92.1254C142.393 91.3158 140.467 90.8896 137.984 90.8896C135.715 90.8896 134.002 91.1879 132.718 91.8697C131.391 92.5515 130.492 93.5741 129.978 94.9803C129.507 96.3013 129.25 98.0909 129.25 100.307C129.25 102.352 129.336 103.971 129.464 105.079C129.592 106.272 129.978 107.338 130.534 108.19C131.134 109.085 132.033 109.766 133.274 110.192C134.43 110.619 135.971 110.789 137.984 110.789C140.039 110.789 141.58 110.619 142.736 110.235C143.977 109.809 144.919 109.042 145.519 107.934C146.075 106.869 146.375 105.377 146.375 103.375V102.736H142.393V102.693Z"
        fill="#1F2A49"
      />
      <path
        d="M158.147 102.95V104.739C158.147 106.018 157.933 106.614 157.762 106.87C157.591 107.168 156.992 107.339 156.135 107.339C154.979 107.339 154.637 107.083 154.551 106.955C154.423 106.785 154.209 106.359 154.209 105.123V94.5979H161.273V91.1038H154.209V86.7148H150.142V91.1038H147.744V94.5979H150.142V105.123C150.142 106.529 150.313 107.637 150.698 108.447C151.083 109.341 151.768 109.981 152.71 110.364C153.567 110.705 154.68 110.875 156.135 110.875C158.49 110.875 160.117 110.236 160.887 108.915C161.615 107.68 162.001 105.975 162.001 103.589V102.95H158.147Z"
        fill="#1F2A49"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5239_28011"
          x1="46.8105"
          y1="42.9822"
          x2="115.022"
          y2="42.9822"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#05809B" />
          <stop offset="1" stopColor="#06CCF7" />
        </linearGradient>
      </defs>
    </svg>
  ),
  logo: (
    <svg
      width="151"
      height="32"
      viewBox="0 0 151 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.422 0.703468C13.5545 0.197082 14.0751 -0.10107 14.5767 0.0314422L32.1157 4.66936C32.622 4.80188 32.9202 5.32246 32.7877 5.82411L27.2174 26.8983C27.0849 27.4046 26.5644 27.7028 26.0627 27.5703L8.52378 22.9324C8.0174 22.7999 7.71924 22.2793 7.85175 21.7776L13.422 0.703468Z"
        fill="#FF0F0F"
      />
      <path
        d="M0.218128 8.32304C0.0998138 7.81192 0.416896 7.30553 0.923282 7.18722L18.5852 3.06041C19.0964 2.9421 19.6028 3.25918 19.7211 3.76557L24.2501 23.1455C24.3685 23.6566 24.0514 24.163 23.545 24.2813L5.88302 28.4081C5.3719 28.5264 4.86552 28.2093 4.7472 27.7029L0.218128 8.32304Z"
        fill="#FFC700"
      />
      <path
        d="M0.946515 9.75195C0.425932 9.75195 0 10.1779 0 10.6985V13.1215V15.5446V31.0533C0 31.5738 0.425932 31.9998 0.946515 31.9998H32.1862C32.7068 31.9998 33.1327 31.5738 33.1327 31.0533V14.0681C33.1327 13.5475 32.7068 13.1215 32.1862 13.1215H15.3856L14.3397 10.3625C14.2025 9.99331 13.8475 9.75195 13.4547 9.75195H0.946515Z"
        fill="url(#paint0_linear_5428_5642)"
      />
      <path
        d="M13.6484 21.9624C13.62 20.2965 13.4733 19.0944 13.1562 18.2615C12.8391 17.3718 12.2002 16.7139 11.3057 16.3401C10.4681 15.9946 9.25181 15.8242 7.62853 15.8242C5.94847 15.8242 4.7322 16.0845 3.92293 16.6288C3.08526 17.1683 2.53155 17.9728 2.27126 18.9761C2.03936 19.8942 1.92578 21.1862 1.92578 22.8474C1.92578 24.0542 2.01097 25.0575 2.15768 25.8289C2.33278 26.6618 2.62147 27.3196 3.08526 27.8355C3.52066 28.3513 4.15482 28.7536 4.96409 28.9808C5.71657 29.2079 6.72934 29.2979 7.91722 29.2979C9.19028 29.2979 10.2031 29.2127 10.9555 29.0376C11.7932 28.8672 12.4605 28.4365 12.9243 27.774C13.4165 27.1445 13.6484 26.198 13.6484 24.9344V24.5132H10.842V25.3462C10.842 26.3779 10.4349 26.553 10.293 26.6382C9.82918 26.8653 9.0767 26.9552 8.12072 26.9552H7.62853C6.67255 26.9552 5.97686 26.8133 5.60299 26.5246C5.22439 26.2359 4.99722 25.8667 4.9073 25.4077C4.82212 24.9202 4.76059 24.2293 4.76059 23.3443H13.6768V21.9671H13.6484V21.9624ZM4.7322 21.0442C4.76059 20.2965 4.84578 19.6955 4.99249 19.2932C5.1392 18.8625 5.39949 18.5738 5.80176 18.4035C6.23716 18.2047 6.89972 18.1148 7.79891 18.1148C8.81168 18.1148 9.56416 18.2 9.99955 18.4035C10.3734 18.5454 10.6053 18.8057 10.6952 19.208C10.8088 19.6103 10.8703 20.2397 10.8987 21.101H4.7322V21.0442Z"
        fill="white"
      />
      <path
        d="M16.6539 17.0732H23.0287C23.289 17.0732 23.502 17.2862 23.502 17.5465V18.5261C23.502 18.7864 23.289 18.9994 23.0287 18.9994H16.6539C16.3936 18.9994 16.1807 18.7864 16.1807 18.5261V17.5465C16.1807 17.2862 16.3936 17.0732 16.6539 17.0732Z"
        fill="white"
      />
      <path
        d="M16.6539 21.8862H27.9411C28.2014 21.8862 28.4144 22.0992 28.4144 22.3595V23.3391C28.4144 23.5994 28.2014 23.8124 27.9411 23.8124H16.6539C16.3936 23.8124 16.1807 23.5994 16.1807 23.3391V22.3595C16.1807 22.0992 16.3936 21.8862 16.6539 21.8862Z"
        fill="white"
      />
      <path
        d="M16.6539 26.7041H30.7333C30.9936 26.7041 31.2066 26.9171 31.2066 27.1774V28.157C31.2066 28.4173 30.9936 28.6303 30.7333 28.6303H16.6539C16.3936 28.6303 16.1807 28.4173 16.1807 28.157V27.1774C16.1807 26.9171 16.3936 26.7041 16.6539 26.7041Z"
        fill="white"
      />
      <path
        d="M51.6302 21.4646C51.6009 19.7726 51.4544 18.5473 51.132 17.7013C50.8096 16.797 50.1648 16.126 49.2562 15.7468C48.4062 15.3967 47.1752 15.2217 45.5338 15.2217C43.8338 15.2217 42.6028 15.4842 41.7821 16.0385C40.9322 16.5928 40.3753 17.4096 40.1115 18.4306C39.877 19.3641 39.7598 20.6769 39.7598 22.3689C39.7598 23.5941 39.8477 24.6152 39.9942 25.4028C40.1701 26.2488 40.4632 26.9198 40.9322 27.4449C41.3718 27.97 42.0166 28.3784 42.8373 28.6118C43.5994 28.8451 44.6252 28.9327 45.8269 28.9327C47.1165 28.9327 48.1424 28.8451 48.9044 28.6701C49.7544 28.4951 50.4285 28.0575 50.8975 27.3865C51.3958 26.7447 51.6302 25.7821 51.6302 24.4985V24.0609H48.7872V24.9069C48.7872 25.9571 48.3769 26.1321 48.2303 26.2196C47.7613 26.453 46.9993 26.5405 46.0321 26.5405H45.5338C44.5666 26.5405 43.8631 26.3947 43.4821 26.1029C43.1011 25.8112 42.8666 25.432 42.7787 24.9652C42.6907 24.4693 42.6321 23.7692 42.6321 22.8648H51.6596V21.4646H51.6302ZM42.6028 20.531C42.6321 19.7726 42.7201 19.1599 42.8666 18.7515C43.0132 18.3139 43.2769 18.0222 43.6873 17.8472C44.1269 17.643 44.8011 17.5555 45.7097 17.5555C46.7355 17.5555 47.4976 17.643 47.9372 17.8472C48.3182 17.993 48.5527 18.2556 48.6406 18.664C48.7579 19.0724 48.8165 19.7142 48.8458 20.5894H42.6028V20.531Z"
        fill="#1F2A49"
      />
      <path
        d="M67.6044 23.0692C67.5751 22.7191 67.5751 22.4566 67.5751 22.2815V21.844H64.7027V22.2815C64.7027 22.4857 64.7027 22.8358 64.732 23.3026C64.7613 23.7693 64.7613 24.0902 64.7613 24.2944C64.732 25.0821 64.4096 25.578 63.7648 25.8697C63.032 26.1906 62.0648 26.3365 60.9217 26.3365C60.7166 26.3365 60.4235 26.3365 60.0424 26.3073C59.6614 26.2781 59.3976 26.2781 59.2511 26.2781C57.4925 26.2781 56.408 25.9572 56.0563 25.3738C55.6167 24.5861 55.4115 23.0108 55.4115 20.6479V16.5054C55.4115 15.6011 55.4701 14.8718 55.6167 14.3467C55.7339 13.8799 55.9684 13.5298 56.3201 13.2673C56.7011 13.0047 57.258 12.8297 58.0201 12.7714C59.3976 12.6839 60.6579 12.6255 61.7717 12.6255C62.6217 12.6255 63.2665 12.7422 63.6476 12.9756C63.9993 13.1798 64.2337 13.4715 64.3217 13.8799C64.4389 14.3758 64.4975 15.1052 64.4975 16.097V16.5346H67.3992L67.3699 16.0678C67.282 14.7843 67.1354 13.7341 66.9596 12.9756C66.7544 12.1879 66.4027 11.5461 65.9044 11.1085C65.4354 10.671 64.7613 10.3792 63.97 10.2042C63.2372 10.0875 62.2114 10 60.9217 10C59.3097 10 58.1373 10.0583 57.3752 10.1459C56.1149 10.2917 55.0891 10.6418 54.3563 11.1961C53.6236 11.7503 53.096 12.5088 52.8029 13.4423C52.5391 14.3175 52.3926 15.3677 52.3926 16.6221V19.481C52.4219 20.327 52.4512 21.3189 52.4805 22.4857C52.5391 23.6818 52.6857 24.732 52.9788 25.6072C53.2719 26.5115 53.8288 27.27 54.5908 27.8826C55.3529 28.4661 56.4373 28.8161 57.7856 28.9036H60.3355C61.3028 28.9036 62.27 28.8745 63.2372 28.8161C66.1096 28.5536 67.6337 26.8616 67.6337 23.9735C67.663 23.7402 67.6337 23.4484 67.6044 23.0692Z"
        fill="#1F2A49"
      />
      <path
        d="M80.1486 17.7599C79.7969 16.7972 79.1521 16.0971 78.2435 15.7178C77.3642 15.3386 76.1039 15.1636 74.4332 15.1636C72.8505 15.1636 71.6781 15.397 70.8281 15.8345C69.9781 16.3013 69.3626 17.0306 69.0695 18.0225C68.8057 18.9268 68.6592 20.1812 68.6592 21.7273V22.9234C68.6592 24.5571 68.835 25.7823 69.2161 26.6283C69.6264 27.5326 70.3005 28.1744 71.2384 28.5245C72.1177 28.8454 73.3488 28.9912 74.9608 28.9912C76.6901 28.9912 77.9504 28.6995 78.8004 28.0869C79.6504 27.4743 80.1779 26.6283 80.3538 25.6073C80.5297 24.6737 80.6176 23.3318 80.6176 21.6107C80.6176 19.9187 80.471 18.6642 80.1486 17.7599ZM77.7452 21.4648C77.7452 22.69 77.7452 23.6527 77.7159 24.2945C77.6866 24.9655 77.5401 25.4906 77.3349 25.8115C77.1297 26.1032 76.8366 26.3074 76.4849 26.3949C76.0453 26.5116 75.4591 26.5699 74.697 26.5699H73.7591C72.6746 26.5699 72.235 26.3657 72.0591 26.1907C71.766 25.8698 71.4143 25.0238 71.4143 22.7775V21.3189C71.4143 20.1229 71.5022 19.2477 71.6488 18.7226C71.766 18.285 72.0298 17.9933 72.4108 17.8474C72.8505 17.6724 73.6125 17.5557 74.697 17.5557H75.1073C76.2504 17.5557 76.778 17.7307 77.0125 17.9058C77.3349 18.11 77.5401 18.4309 77.628 18.8685C77.6866 19.4227 77.7452 20.2979 77.7452 21.4648Z"
        fill="#1F2A49"
      />
      <path
        d="M92.6347 17.2054C92.283 16.4469 91.7261 15.8926 90.9934 15.5717C90.2606 15.2508 89.3227 15.105 88.121 15.105C87.0952 15.105 86.1866 15.2508 85.4245 15.5426C84.9849 15.7176 84.6038 15.951 84.2521 16.2719V15.3967H81.6729V28.7868H84.428V20.6769C84.428 18.5181 85.4831 17.5263 87.7107 17.5263C88.5314 17.5263 89.1175 17.6138 89.4986 17.7597C89.821 17.9055 90.0262 18.1097 90.1434 18.4306C90.2899 18.8099 90.3486 19.4225 90.3486 20.2101V28.7868H93.133V20.0643C93.133 18.8682 92.9571 17.9055 92.6347 17.2054Z"
        fill="#1F2A49"
      />
      <path
        d="M101.163 23.5067V24.732C101.163 25.6071 101.017 26.0156 100.9 26.1906C100.782 26.3948 100.372 26.5115 99.7857 26.5115C98.9944 26.5115 98.7599 26.3364 98.7013 26.2489C98.6133 26.1322 98.4668 25.8405 98.4668 24.9945V17.789H103.303V15.3968H98.4668V12.3921H95.6824V15.3968H94.041V17.789H95.6824V24.9945C95.6824 25.9572 95.7996 26.7157 96.0634 27.27C96.3272 27.8826 96.7961 28.3202 97.441 28.5827C98.0271 28.8161 98.7892 28.9328 99.7857 28.9328C101.398 28.9328 102.512 28.4952 103.039 27.5909C103.537 26.7449 103.801 25.578 103.801 23.9443V23.5067H101.163Z"
        fill="#1F2A49"
      />
      <path
        d="M110.484 15.105C109.282 15.105 108.286 15.4259 107.524 16.0677V15.3967H104.827V28.7868H107.582V20.0059C107.582 18.3139 108.374 17.5263 110.074 17.5263C110.806 17.5263 111.275 17.7013 111.48 18.0222C111.715 18.4306 111.862 19.0724 111.862 19.9476V20.3852H114.558V19.9476C114.558 15.951 112.33 15.105 110.484 15.105Z"
        fill="#1F2A49"
      />
      <path
        d="M126.517 17.1472C126.048 16.4179 125.374 15.9219 124.494 15.6886C123.703 15.4844 122.618 15.3677 121.299 15.3677C119.482 15.3677 118.193 15.6011 117.313 16.0678C116.375 16.5929 115.877 17.7306 115.877 19.4518V19.8894H118.691V19.4518C118.691 19.3351 118.662 19.2476 118.632 19.1309C118.603 19.0434 118.603 19.0142 118.603 19.0142C118.603 18.5183 118.72 18.1682 118.984 17.9932C119.218 17.8181 119.775 17.5848 121.124 17.5848C122.149 17.5848 122.911 17.6431 123.351 17.789C123.703 17.9057 123.937 18.1099 124.084 18.4891C124.26 18.9267 124.318 19.6268 124.318 20.6187V21.0271C124.025 20.8229 123.674 20.677 123.293 20.5895C122.618 20.4437 121.768 20.3561 120.743 20.3561C119.629 20.3561 118.72 20.4437 117.987 20.6479C117.196 20.8521 116.551 21.2897 116.112 21.9023C115.672 22.5149 115.438 23.4192 115.438 24.5569C115.438 25.753 115.643 26.6574 116.082 27.2991C116.522 27.9701 117.137 28.4077 117.958 28.6411C118.691 28.8453 119.658 28.962 120.83 28.962C121.886 28.962 122.765 28.8453 123.468 28.6411C123.849 28.5244 124.201 28.3493 124.524 28.116L124.465 28.7286H127.161V20.2103C127.191 18.8392 126.956 17.8473 126.517 17.1472ZM124.494 24.6736C124.494 25.2863 124.348 25.6947 124.025 25.9572C123.674 26.2489 123.263 26.424 122.765 26.4823C122.237 26.5698 121.534 26.599 120.743 26.599C119.541 26.599 119.013 26.3656 118.779 26.1614C118.456 25.8989 118.31 25.2863 118.31 24.3819C118.31 23.5067 118.515 23.2442 118.574 23.1859L118.603 23.1567C118.779 22.9816 119.336 22.7191 120.977 22.7191H121.446C122.53 22.7191 123.351 22.8358 123.879 23.0983C124.289 23.3025 124.494 23.8276 124.494 24.6736Z"
        fill="#1F2A49"
      />
      <path
        d="M137.244 23.3317V23.7693C137.244 24.6736 137.156 25.3154 136.98 25.6947C136.834 26.0156 136.599 26.2198 136.218 26.3364C135.779 26.4531 135.075 26.5115 134.108 26.5115C133.141 26.5115 132.437 26.3948 132.027 26.1322C131.646 25.8989 131.412 25.578 131.294 25.1112C131.177 24.5861 131.118 23.7693 131.118 22.7191V21.4647C131.118 20.2686 131.206 19.3934 131.353 18.8392C131.499 18.4016 131.734 18.0807 132.144 17.9348C132.613 17.7306 133.375 17.6431 134.46 17.6431C135.163 17.6431 135.72 17.7014 136.101 17.8473C136.424 17.964 136.629 18.139 136.775 18.4308C136.951 18.7517 137.01 19.2476 137.01 19.9477V20.3853H139.706V19.5393C139.706 17.8473 139.179 16.7096 138.182 16.097C137.244 15.5427 135.925 15.251 134.225 15.251C132.672 15.251 131.499 15.4552 130.62 15.9219C129.712 16.3887 129.096 17.0888 128.744 18.0515C128.422 18.9559 128.246 20.1811 128.246 21.6981C128.246 23.0983 128.305 24.2069 128.393 24.9654C128.481 25.7822 128.744 26.5115 129.125 27.0949C129.536 27.7075 130.151 28.1743 131.001 28.466C131.793 28.7577 132.848 28.8744 134.225 28.8744C135.632 28.8744 136.687 28.7577 137.479 28.4952C138.329 28.2035 138.973 27.6784 139.384 26.9199C139.765 26.1906 139.97 25.1696 139.97 23.7985V23.3609H137.244V23.3317Z"
        fill="#1F2A49"
      />
      <path
        d="M148.03 23.5067V24.732C148.03 25.6071 147.884 26.0156 147.767 26.1906C147.649 26.3948 147.239 26.5115 146.653 26.5115C145.862 26.5115 145.627 26.3364 145.568 26.2489C145.481 26.1322 145.334 25.8405 145.334 24.9945V17.789H150.17V15.3968H145.334V12.3921H142.55V15.3968H140.908V17.789H142.55V24.9945C142.55 25.9572 142.667 26.7157 142.931 27.27C143.194 27.8826 143.663 28.3202 144.308 28.5827C144.894 28.8161 145.656 28.9328 146.653 28.9328C148.265 28.9328 149.379 28.4952 149.906 27.5909C150.405 26.7449 150.668 25.578 150.668 23.9443V23.5067H148.03Z"
        fill="#1F2A49"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5428_5642"
          x1="0"
          y1="20.8768"
          x2="33.1315"
          y2="20.8768"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#05809B" />
          <stop offset="1" stopColor="#06CCF7" />
        </linearGradient>
      </defs>
    </svg>
  ),
  add: (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M8 1.83398V15.1673"
          stroke={'white'}
          strokeWidth="1.3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6663 8.5H1.33301"
          stroke={'white'}
          strokeWidth="1.3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  search: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
        fill={'#2160bd'}
      />
    </svg>
  ),
  arrowDown: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 4.5L8 12L0.5 4.5"
        stroke="#868E96"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'arrow-menu': (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3335 4.6665H4.66682C4.42482 4.6665 4.20148 4.79784 4.08348 5.00984C3.96615 5.22184 3.97282 5.48117 4.10148 5.6865L7.43482 11.0198C7.55682 11.2145 7.77015 11.3332 8.00015 11.3332C8.23015 11.3332 8.44348 11.2145 8.56548 11.0198L11.8988 5.6865C12.0275 5.48117 12.0341 5.22184 11.9168 5.00984C11.7988 4.79784 11.5755 4.6665 11.3335 4.6665Z"
        fill="rgba(0, 0, 0, 0.5)"
      />
    </svg>
  ),
  trashCan: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.1" cx="24" cy="24" r="24" fill="#BC2618" />
      <path
        d="M32.25 16.5V33.5455C32.25 34.4868 31.5784 35.25 30.75 35.25H17.25C16.4216 35.25 15.75 34.4868 15.75 33.5455V16.5"
        stroke="#B20D0D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 22.125V30.375"
        stroke="#B20D0D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.25 22.125V30.375"
        stroke="#B20D0D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.75 22.125V30.375"
        stroke="#B20D0D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.25 16.5V12.75H27.75V16.5"
        stroke="#B20D0D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.5 16.5H13.5"
        stroke="#B20D0D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <clipPath id="clip0">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  threeDots: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
        stroke="#868E96"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M3 14C4.10457 14 5 13.1046 5 12C5 10.8954 4.10457 10 3 10C1.89543 10 1 10.8954 1 12C1 13.1046 1.89543 14 3 14Z"
        stroke="#868E96"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M21 14C22.1046 14 23 13.1046 23 12C23 10.8954 22.1046 10 21 10C19.8954 10 19 10.8954 19 12C19 13.1046 19.8954 14 21 14Z"
        stroke="#868E96"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  ),
  dot: (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4" cy="4" r="4" fill={'rgba(0, 0, 0, 0.5)'} />
    </svg>
  ),
  stationery: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1001 4.40002H20.5001"
        stroke="#27AE60"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M17.1001 10H20.5001"
        stroke="#27AE60"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M19 7.19995H20.5"
        stroke="#27AE60"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M5.8001 13.2L2.1001 7.40002L2.4001 2.40002L7.1001 4.40002L12.7001 13.3"
        stroke="#27AE60"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2002 13V1H20.5002V13"
        stroke="#27AE60"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M20 13.5H22V23H2V13.5H20Z"
        stroke="#27AE60"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  menu: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 18H16V16H3V18ZM3 13H13V11H3V13ZM3 6V8H16V6H3ZM21 15.59L17.42 12L21 8.41L19.59 7L14.59 12L19.59 17L21 15.59Z"
        fill="#222D4B"
      />
    </svg>
  ),
  meeting: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.992 18.7373L8.2 20.4003C8.704 20.7783 9 21.3703 9 22.0003V23.0003H1V22.0003C1 21.3703 1.296 20.7783 1.8 20.4003L4.008 18.7373"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 19C3.895 19 3 18.105 3 17V16C3 14.895 3.895 14 5 14C6.105 14 7 14.895 7 16V17C7 18.105 6.105 19 5 19Z"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.992 5.7373L15.2 7.4003C15.704 7.7783 16 8.3703 16 9.0003V10.0003H8V9.0003C8 8.3703 8.296 7.7783 8.8 7.4003L11.008 5.7373"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6C10.895 6 10 5.105 10 4V3C10 1.895 10.895 1 12 1C13.105 1 14 1.895 14 3V4C14 5.105 13.105 6 12 6Z"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.992 18.7373L22.2 20.4003C22.704 20.7783 23 21.3703 23 22.0003V23.0003H15V22.0003C15 21.3703 15.296 20.7783 15.8 20.4003L18.008 18.7373"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 19C17.895 19 17 18.105 17 17V16C17 14.895 17.895 14 19 14C20.105 14 21 14.895 21 16V17C21 18.105 20.105 19 19 19Z"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'access-key': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M11.2424 21.2426C13.5856 18.8995 13.5856 15.1005 11.2424 12.7574C8.89932 10.4143 5.10037 10.4143 2.75725 12.7574C0.414125 15.1005 0.414125 18.8995 2.75725 21.2426C5.10037 23.5857 8.89932 23.5857 11.2424 21.2426Z"
          stroke="#F2994A"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.2432 12.757L22.0002 2"
          stroke="#F2994A"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 5L22 8L19 11L16 8"
          stroke="#F2994A"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  'add-blue': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2V22"
        stroke="#2196F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 12H2"
        stroke="#2196F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'close-icon': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#CED4DA" />
      <path
        d="M16.6663 7.33337L7.33301 16.6667"
        stroke="#868E96"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6663 16.6667L7.33301 7.33337"
        stroke="#868E96"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'filter-remove': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 9H23"
        stroke="#EB5757"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M1 3H23"
        stroke="#EB5757"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M1 15H11"
        stroke="#EB5757"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M1 21H11"
        stroke="#EB5757"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M16 15L22 21"
        stroke="#EB5757"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M22 15L16 21"
        stroke="#EB5757"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  ),
  check: (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="hjustice://www.w3.org/2000/svg"
    >
      <path
        d="M1 5L5 9L13 1"
        stroke="#1574F6"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'role-group': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 4V20C3 21.7 7 23 12 23C17 23 21 21.7 21 20V4"
        stroke="#56CCF2"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M12 7C16.9706 7 21 5.65685 21 4C21 2.34315 16.9706 1 12 1C7.02944 1 3 2.34315 3 4C3 5.65685 7.02944 7 12 7Z"
        stroke="#56CCF2"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M21 12C21 13.7 17 15 12 15C7 15 3 13.7 3 12"
        stroke="#56CCF2"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  ),
  authorization: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.992 18.7371L8.2 20.4001C8.704 20.7781 9 21.3701 9 22.0001V23.0001H1V22.0001C1 21.3701 1.296 20.7781 1.8 20.4001L4.008 18.7371"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 19C3.895 19 3 18.105 3 17V16C3 14.895 3.895 14 5 14C6.105 14 7 14.895 7 16V17C7 18.105 6.105 19 5 19Z"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.992 5.73706L15.2 7.40006C15.704 7.77806 16 8.37006 16 9.00006V10.0001H8V9.00006C8 8.37006 8.296 7.77806 8.8 7.40006L11.008 5.73706"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6C10.895 6 10 5.105 10 4V3C10 1.895 10.895 1 12 1C13.105 1 14 1.895 14 3V4C14 5.105 13.105 6 12 6Z"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.992 18.7371L22.2 20.4001C22.704 20.7781 23 21.3701 23 22.0001V23.0001H15V22.0001C15 21.3701 15.296 20.7781 15.8 20.4001L18.008 18.7371"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 19C17.895 19 17 18.105 17 17V16C17 14.895 17.895 14 19 14C20.105 14 21 14.895 21 16V17C21 18.105 20.105 19 19 19Z"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'notice-error': (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.3335 28H30.6668L16.0002 2.66666L1.3335 28ZM5.96016 25.3333L16.0002 7.98666L26.0402 25.3333H5.96016ZM14.6668 21.3333H17.3335V24H14.6668V21.3333ZM14.6668 13.3333H17.3335V18.6667H14.6668V13.3333Z"
        fill="#E13F3D"
      />
    </svg>
  ),
  'notice-success': (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.6861 14.1597C28.0165 15.7411 28.1152 17.4848 27.8027 19.2574C26.5524 26.348 19.8333 31.0528 12.7427 29.8025C5.65211 28.5522 0.947385 21.8332 2.19765 14.7426C3.44792 7.65195 10.167 2.94722 17.2576 4.19749C19.7196 4.63161 21.9616 5.73773 23.7055 7.36528"
        stroke="#27AE60"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M10 16L15 21L30 6"
        stroke="#27AE60"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'icon-arrow-down': (
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 0L0.999979 0C0.636979 0 0.301979 0.197 0.124979 0.515C-0.0510214 0.833 -0.0410214 1.222 0.151979 1.53L5.15198 9.53C5.33498 9.822 5.65498 10 5.99998 10C6.34498 10 6.66498 9.822 6.84798 9.53L11.848 1.53C12.041 1.222 12.051 0.833 11.875 0.515C11.698 0.197 11.363 0 11 0Z"
        fill="#868E96"
      />
    </svg>
  ),
  faq: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 16H11V14H9V16ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 4C7.79 4 6 5.79 6 8H8C8 6.9 8.9 6 10 6C11.1 6 12 6.9 12 8C12 10 9 9.75 9 13H11C11 10.75 14 10.5 14 8C14 5.79 12.21 4 10 4Z"
        fill="#1574F6"
      />
    </svg>
  ),
  warning: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33331 28H30.6666L16 2.66663L1.33331 28ZM17.3333 24H14.6666V21.3333H17.3333V24ZM17.3333 18.6666H14.6666V13.3333H17.3333V18.6666Z"
        fill="#E65100"
      />
    </svg>
  ),
  t_warning_default: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="hjustice://www.w3.org/2000/svg"
    >
      <path
        d="M2 22L12 3L22 22H2Z"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12 11V15"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19Z"
        fill="#F57C00"
      />
    </svg>
  ),
  arrow_down: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3335 4.66669L4.66682 4.66669C4.42482 4.66669 4.20148 4.79802 4.08348 5.01002C3.96615 5.22202 3.97282 5.48135 4.10148 5.68669L7.43482 11.02C7.55682 11.2147 7.77015 11.3334 8.00015 11.3334C8.23015 11.3334 8.44348 11.2147 8.56548 11.02L11.8988 5.68669C12.0275 5.48135 12.0341 5.22202 11.9168 5.01002C11.7988 4.79802 11.5755 4.66669 11.3335 4.66669Z"
        fill="#868E96"
      />
    </svg>
  ),
  arrow_down_white: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3335 4.66666L4.66682 4.66666C4.42482 4.66666 4.20148 4.79799 4.08348 5.00999C3.96615 5.22199 3.97282 5.48132 4.10148 5.68666L7.43482 11.02C7.55682 11.2147 7.77015 11.3333 8.00015 11.3333C8.23015 11.3333 8.44348 11.2147 8.56548 11.02L11.8988 5.68666C12.0275 5.48132 12.0341 5.22199 11.9168 5.00999C11.7988 4.79799 11.5755 4.66666 11.3335 4.66666Z"
        fill="white"
      />
    </svg>
  ),
  process_group: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path d="M20 6H10V8H20V6Z" fill="#F2994A" />
        <path
          d="M2.26668 21.1875V2.81249C2.26668 2.29554 2.77506 1.87499 3.39998 1.87499H19.6001C20.225 1.87499 20.7334 2.29554 20.7334 2.81249V10.0683L23 12V2.81249C23 1.26168 21.4748 0 19.6001 0H3.39998C1.52526 0 0 1.26168 0 2.81249V21.1875C0 22.7383 1.5252 24 3.39993 24H10L10.5 22.125H3.39998C2.77506 22.125 2.26668 21.7045 2.26668 21.1875Z"
          fill="#F2994A"
        />
        <path d="M20 11H10V13H18L20 11Z" fill="#F2994A" />
        <path
          d="M20.117 12L13.8232 18.4717C13.4635 18.8328 13.1888 19.2791 13.0285 19.7629L13.0143 19.8058L12 24L16.4723 23.265L16.5165 23.2503C17.0027 23.0894 17.4512 22.8131 17.8134 22.451L24.1063 15.9804L20.117 12ZM16.4851 21.1301C16.45 21.1648 16.413 21.1976 16.3745 21.2284L15.0515 19.9045C15.0832 19.8651 15.117 19.8273 15.1527 19.7916L20.137 14.6665L21.4738 16.0003L16.4851 21.1301Z"
          fill="#F2994A"
        />
        <path
          d="M8.48433 9.40326L6.19176 12.0036L5.05096 10.9323L3.76855 12.298L6.31856 14.6926L9.8896 10.6423L8.48433 9.40326Z"
          fill="#F2994A"
        />
        <path
          d="M8.48433 3.73624L6.19176 6.33654L5.05096 5.26526L3.76855 6.63097L6.31856 9.02554L9.8896 4.97519L8.48433 3.73624Z"
          fill="#F2994A"
        />
        <path
          d="M5.05096 16.5526L3.76855 17.9183L6.31856 20.3129L9.8896 16.2626L8.48433 15.0236L6.19176 17.6239L5.05096 16.5526Z"
          fill="#F2994A"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  'menu-log-work': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.42857 19V20.5C7.42857 22.75 5 23 5 23C5 23 19.4053 23 19.5714 23C20.913 23 22 21.881 22 20.5V19H7.42857Z"
        stroke="#FF5722"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 1H2V20.5C2 21.881 3.119 23 4.5 23H6"
        stroke="#FF5722"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 15C19.7614 15 22 12.7614 22 10C22 7.23858 19.7614 5 17 5C14.2386 5 12 7.23858 12 10C12 12.7614 14.2386 15 17 15Z"
        stroke="#FF5722"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 8V10H19"
        stroke="#FF5722"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 6H9"
        stroke="#FF5722"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 10H9"
        stroke="#FF5722"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 14H9"
        stroke="#FF5722"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'menu-product': (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66732 13.3327H13.334V14.9993H6.66732V13.3327ZM6.66732 9.99935H13.334V11.666H6.66732V9.99935ZM11.6673 1.66602H5.00065C4.08398 1.66602 3.33398 2.41602 3.33398 3.33268V16.666C3.33398 17.5827 4.07565 18.3327 4.99232 18.3327H15.0007C15.9173 18.3327 16.6673 17.5827 16.6673 16.666V6.66602L11.6673 1.66602ZM15.0007 16.666H5.00065V3.33268H10.834V7.49935H15.0007V16.666Z"
        fill="#212529"
      />
    </svg>
  ),
  'menu-config': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13C9.176 13 6.671 13.638 5.025 14.193C3.81 14.604 3 15.749 3 17.032V21H12.5"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 13C13.824 13 16.329 13.638 17.975 14.193C19.19 14.604 20 15.749 20 17.032V21H12"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13C9.239 13 7 9.761 7 7V6C7 3.239 9.239 1 12 1C14.761 1 17 3.239 17 6V7C17 9.761 14.761 13 12 13Z"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  ),
  'menu-role-group': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 5V1H16V5"
        stroke="#2196F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 15H1V5H23V15H15"
        stroke="#2196F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 18V23H2V18"
        stroke="#2196F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 13H9V17H15V13Z"
        stroke="#2196F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'menu-authori': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 13C7.176 13 4.671 13.638 3.025 14.193C1.81 14.604 1 15.749 1 17.032V21H9"
        stroke="#7B1FA2"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13C7.239 13 5 9.761 5 7V6C5 3.239 7.239 1 10 1C12.761 1 15 3.239 15 6V7C15 9.761 12.761 13 10 13Z"
        stroke="#7B1FA2"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M17.4195 20.1937C18.4172 19.196 18.4172 17.5784 17.4195 16.5807C16.4218 15.583 14.8042 15.583 13.8065 16.5807C12.8088 17.5784 12.8088 19.196 13.8065 20.1937C14.8042 21.1914 16.4218 21.1914 17.4195 20.1937Z"
        stroke="#7B1FA2"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4199 16.5804L22.0003 12"
        stroke="#7B1FA2"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7227 13.2773L22.0001 14.5548L20.7227 15.8322L19.4453 14.5548"
        stroke="#7B1FA2"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'filter-black': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M22 0H2C1.73478 0 1.48043 0.105357 1.29289 0.292893C1.10536 0.48043 1 0.734784 1 1V4C1.00006 4.26519 1.10545 4.51951 1.293 4.707L9 12.414V23C9 23.1857 9.05171 23.3678 9.14935 23.5257C9.24698 23.6837 9.38668 23.8114 9.55279 23.8944C9.71889 23.9775 9.90484 24.0126 10.0898 23.996C10.2748 23.9793 10.4514 23.9114 10.6 23.8L14.6 20.8C14.7242 20.7069 14.825 20.5861 14.8944 20.4472C14.9639 20.3084 15 20.1552 15 20V12.414L22.707 4.707C22.8946 4.51951 22.9999 4.26519 23 4V1C23 0.734784 22.8946 0.48043 22.7071 0.292893C22.5196 0.105357 22.2652 0 22 0V0Z"
          fill="#616161"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  confirm: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12L10 16L18 8"
        stroke="#18BC78"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  history: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 7V12L16 16"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C8.1 2 4.7 4.2 3.1 7.5"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.26392 2.56982L3.09992 7.49982L8.02992 6.66382"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'edit-course': (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7167 7.51667L12.4833 8.28333L4.93333 15.8333H4.16667V15.0667L11.7167 7.51667ZM14.7167 2.5C14.5083 2.5 14.2917 2.58333 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C15.1417 2.575 14.9333 2.5 14.7167 2.5ZM11.7167 5.15833L2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833Z"
        fill="#00AEAC"
      />
    </svg>
  ),
  edit: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 16.8739H3.75C3.58424 16.8739 3.42527 16.8081 3.30806 16.6909C3.19085 16.5737 3.125 16.4147 3.125 16.2489V12.7578C3.125 12.6757 3.14117 12.5945 3.17258 12.5186C3.20398 12.4428 3.25002 12.3739 3.30806 12.3159L12.6831 2.94087C12.8003 2.82366 12.9592 2.75781 13.125 2.75781C13.2908 2.75781 13.4497 2.82366 13.5669 2.94087L17.0581 6.43199C17.1753 6.5492 17.2411 6.70817 17.2411 6.87393C17.2411 7.03969 17.1753 7.19866 17.0581 7.31587L7.5 16.8739Z"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.625 5L15 9.375"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'arrow-right': (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66699 4.66652L4.66699 11.3332C4.66699 11.5752 4.79833 11.7985 5.01033 11.9165C5.22233 12.0339 5.48166 12.0272 5.68699 11.8985L11.0203 8.56518C11.215 8.44318 11.3337 8.22985 11.3337 7.99985C11.3337 7.76985 11.215 7.55652 11.0203 7.43452L5.68699 4.10118C5.48166 3.97252 5.22233 3.96585 5.01033 4.08318C4.79833 4.20118 4.66699 4.42452 4.66699 4.66652Z"
        fill={'#616161'}
      />
    </svg>
  ),
  'arrow-down': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_82_19447)">
        <path d="M12 16L6 10L18 10L12 16Z" fill="#6A7688" />
      </g>
      <defs>
        <clipPath id="clip0_82_19447">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(24) rotate(90)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  calendar: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 3.33268H15V2.49935C15 2.04102 14.625 1.66602 14.1667 1.66602C13.7083 1.66602 13.3333 2.04102 13.3333 2.49935V3.33268H6.66667V2.49935C6.66667 2.04102 6.29167 1.66602 5.83333 1.66602C5.375 1.66602 5 2.04102 5 2.49935V3.33268H4.16667C3.24167 3.33268 2.50833 4.08268 2.50833 4.99935L2.5 16.666C2.5 17.5827 3.24167 18.3327 4.16667 18.3327H15.8333C16.75 18.3327 17.5 17.5827 17.5 16.666V4.99935C17.5 4.08268 16.75 3.33268 15.8333 3.33268ZM15.8333 15.8327C15.8333 16.291 15.4583 16.666 15 16.666H5C4.54167 16.666 4.16667 16.291 4.16667 15.8327V7.49935H15.8333V15.8327ZM5.83333 9.16602H7.5V10.8327H5.83333V9.16602ZM9.16667 9.16602H10.8333V10.8327H9.16667V9.16602ZM12.5 9.16602H14.1667V10.8327H12.5V9.16602Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  warning_default: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33301 14.6667L7.99967 2L14.6663 14.6667H1.33301Z"
        stroke="#18BC78"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M8 7.33398V10.0007"
        stroke="#18BC78"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M7.99967 12.6673C8.36786 12.6673 8.66634 12.3688 8.66634 12.0007C8.66634 11.6325 8.36786 11.334 7.99967 11.334C7.63148 11.334 7.33301 11.6325 7.33301 12.0007C7.33301 12.3688 7.63148 12.6673 7.99967 12.6673Z"
        fill="#18BC78"
      />
    </svg>
  ),
  warning_green: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33301 14.6667L7.99967 2L14.6663 14.6667H1.33301Z"
        stroke="#18BC78"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M8 7.33398V10.0007"
        stroke="#18BC78"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M7.99967 12.6673C8.36786 12.6673 8.66634 12.3688 8.66634 12.0007C8.66634 11.6325 8.36786 11.334 7.99967 11.334C7.63148 11.334 7.33301 11.6325 7.33301 12.0007C7.33301 12.3688 7.63148 12.6673 7.99967 12.6673Z"
        fill="#18BC78"
      />
    </svg>
  ),
  warning_yellow: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33301 14.6667L7.99967 2L14.6663 14.6667H1.33301Z"
        stroke="#F2994A"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M8 7.33398V10.0007"
        stroke="#F2994A"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M7.99967 12.6673C8.36786 12.6673 8.66634 12.3688 8.66634 12.0007C8.66634 11.6325 8.36786 11.334 7.99967 11.334C7.63148 11.334 7.33301 11.6325 7.33301 12.0007C7.33301 12.3688 7.63148 12.6673 7.99967 12.6673Z"
        fill="#F2994A"
      />
    </svg>
  ),
  warning_red: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.3335 14.6667L8.00016 2L14.6668 14.6667H1.3335Z"
        stroke="#BC2618"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M8 7.33398V10.0007"
        stroke="#BC2618"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.00016 12.6673C8.36835 12.6673 8.66683 12.3688 8.66683 12.0007C8.66683 11.6325 8.36835 11.334 8.00016 11.334C7.63197 11.334 7.3335 11.6325 7.3335 12.0007C7.3335 12.3688 7.63197 12.6673 8.00016 12.6673Z"
        fill="#BC2618"
      />
    </svg>
  ),
  'confirm-lw': (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.1" cx="24" cy="24" r="24" fill="#F57C00" />
      <path
        d="M14 32L24 13L34 32H14Z"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M24 21V25"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M24 29C24.5523 29 25 28.5523 25 28C25 27.4477 24.5523 27 24 27C23.4477 27 23 27.4477 23 28C23 28.5523 23.4477 29 24 29Z"
        fill="#F57C00"
      />
    </svg>
  ),
  'file-text': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM10 9H18V11H10V9ZM10 12H14V14H10V12ZM10 6H18V8H10V6Z"
        fill={'rgba(0, 0, 0, 0.5)'}
      />
    </svg>
  ),
  folder: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.17 6L11.17 8H20V18H4V6H9.17ZM10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10 4Z"
        fill="rgba(0, 0, 0, 0.5)"
      />
    </svg>
  ),
  vbm: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83333 12.5007H11.6667V14.1673H5.83333V12.5007ZM5.83333 9.16732H14.1667V10.834H5.83333V9.16732ZM5.83333 5.83398H14.1667V7.50065H5.83333V5.83398ZM15.8333 2.50065H12.35C12 1.53398 11.0833 0.833984 10 0.833984C8.91667 0.833984 8 1.53398 7.65 2.50065H4.16667C4.05 2.50065 3.94167 2.50898 3.83333 2.53398C3.50833 2.60065 3.21667 2.76732 2.99167 2.99232C2.84167 3.14232 2.71667 3.32565 2.63333 3.52565C2.55 3.71732 2.5 3.93398 2.5 4.16732V15.834C2.5 16.059 2.55 16.284 2.63333 16.484C2.71667 16.684 2.84167 16.859 2.99167 17.0173C3.21667 17.2423 3.50833 17.409 3.83333 17.4757C3.94167 17.4923 4.05 17.5007 4.16667 17.5007H15.8333C16.75 17.5007 17.5 16.7507 17.5 15.834V4.16732C17.5 3.25065 16.75 2.50065 15.8333 2.50065ZM10 2.29232C10.3417 2.29232 10.625 2.57565 10.625 2.91732C10.625 3.25898 10.3417 3.54232 10 3.54232C9.65833 3.54232 9.375 3.25898 9.375 2.91732C9.375 2.57565 9.65833 2.29232 10 2.29232ZM15.8333 15.834H4.16667V4.16732H15.8333V15.834Z"
        fill="#777"
      />
    </svg>
  ),
  people: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.67 13.1299C18.04 14.0599 19 15.3199 19 16.9999V19.9999H23V16.9999C23 14.8199 19.43 13.5299 16.67 13.1299Z"
        fill="rgba(0, 0, 0, 0.5)"
      />
      <path
        d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z"
        fill="rgba(0, 0, 0, 0.5)"
      />
      <path
        d="M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z"
        fill="rgba(0, 0, 0, 0.5)"
      />
      <path
        d="M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13ZM15 18H3V17.01C3.2 16.29 6.3 15 9 15C11.7 15 14.8 16.29 15 17V18Z"
        fill="rgba(0, 0, 0, 0.5)"
      />
    </svg>
  ),
  'icon-confirm': (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M59.9994 26.6665C41.666 26.6665 26.666 41.6665 26.666 59.9998C26.666 78.3332 41.666 93.3332 59.9994 93.3332C78.3327 93.3332 93.3327 78.3332 93.3327 59.9998C93.3327 41.6665 78.3327 26.6665 59.9994 26.6665ZM59.9994 86.6665C45.2994 86.6665 33.3327 74.6998 33.3327 59.9998C33.3327 45.2998 45.2994 33.3332 59.9994 33.3332C74.6994 33.3332 86.666 45.2998 86.666 59.9998C86.666 74.6998 74.6994 86.6665 59.9994 86.6665ZM61.666 43.3332H56.666V63.3332L73.9994 73.9998L76.666 69.6665L61.666 60.6665V43.3332Z"
        fill="#E50500"
      />
      <circle cx="60" cy="60" r="59.5" stroke="#E50500" strokeDasharray="5 5" />
    </svg>
  ),
  download: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.71875 8.59473L10 11.8751L13.2812 8.59473"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3.125V11.8727"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.875 11.875V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'icon-system': (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8833 3.76654L16.2417 6.12487L13.8833 8.4832L11.525 6.12487L13.8833 3.76654ZM7.5 4.16654V7.49987H4.16667V4.16654H7.5ZM15.8333 12.4999V15.8332H12.5V12.4999H15.8333ZM7.5 12.4999V15.8332H4.16667V12.4999H7.5ZM13.8833 1.4082L9.16667 6.11654L13.8833 10.8332L18.6 6.11654L13.8833 1.4082ZM9.16667 2.49987H2.5V9.16654H9.16667V2.49987ZM17.5 10.8332H10.8333V17.4999H17.5V10.8332ZM9.16667 10.8332H2.5V17.4999H9.16667V10.8332Z"
        fill="#212529"
      />
    </svg>
  ),
  eye: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 4.37402C3.75 4.37402 1.25 9.99963 1.25 9.99963C1.25 9.99963 3.75 15.624 10 15.624C16.25 15.624 18.75 9.99963 18.75 9.99963C18.75 9.99963 16.25 4.37402 10 4.37402Z"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.125C11.7259 13.125 13.125 11.7259 13.125 10C13.125 8.27411 11.7259 6.875 10 6.875C8.27411 6.875 6.875 8.27411 6.875 10C6.875 11.7259 8.27411 13.125 10 13.125Z"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'download-grey': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0028 12.0759C11.001 12.0508 11 12.0255 11 12V4C11 3.448 11.447 3 12 3C12.553 3 13 3.448 13 4V11.9998L15.4 10.2C15.842 9.867 16.469 9.958 16.8 10.4C17.132 10.842 17.042 11.469 16.6 11.8L12.6 14.8C12.423 14.933 12.211 15 12 15C11.799 15 11.598 14.939 11.425 14.818L7.425 12.004C6.973 11.686 6.864 11.062 7.182 10.611C7.5 10.159 8.123 10.05 8.575 10.368L11.0028 12.0759ZM6 17V18H18V17C18 16.45 18.45 16 19 16C19.55 16 20 16.45 20 17V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V17C4 16.45 4.45 16 5 16C5.55 16 6 16.45 6 17Z"
        fill="#757575"
      />
      <mask
        id="mask0"
        {...{ 'mask-type': 'alpha' }} // ✅ truyền trực tiếp attribute gốc SVG
        maskUnits="userSpaceOnUse"
        x="4"
        y="3"
        width="16"
        height="17"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.0028 12.0759C11.001 12.0508 11 12.0255 11 12V4C11 3.448 11.447 3 12 3C12.553 3 13 3.448 13 4V11.9998L15.4 10.2C15.842 9.867 16.469 9.958 16.8 10.4C17.132 10.842 17.042 11.469 16.6 11.8L12.6 14.8C12.423 14.933 12.211 15 12 15C11.799 15 11.598 14.939 11.425 14.818L7.425 12.004C6.973 11.686 6.864 11.062 7.182 10.611C7.5 10.159 8.123 10.05 8.575 10.368L11.0028 12.0759ZM6 17V18H18V17C18 16.45 18.45 16 19 16C19.55 16 20 16.45 20 17V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V17C4 16.45 4.45 16 5 16C5.55 16 6 16.45 6 17Z"
          fill="white"
        />
      </mask>
    </svg>
  ),
  'warning-cancel': (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M83.3334 41.3666L78.6334 36.6666L60.0001 55.3L41.3667 36.6666L36.6667 41.3666L55.3001 60L36.6667 78.6333L41.3667 83.3333L60.0001 64.7L78.6334 83.3333L83.3334 78.6333L64.7001 60L83.3334 41.3666Z"
        fill="#E50500"
      />
      <circle cx="60" cy="60" r="59.5" stroke="#E50500" strokeDasharray="5 5" />
    </svg>
  ),
  sign_success: (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="32" cy="32" r="32" fill="#373839" />
      <path
        d="M20 32L28 40L44 24"
        stroke="#18BC78"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  eye_orange: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 10.4996C11.173 10.4996 10.5 11.1726 10.5 11.9996C10.5 12.8266 11.173 13.4996 12 13.4996C12.827 13.4996 13.5 12.8266 13.5 11.9996C13.5 11.1726 12.827 10.4996 12 10.4996ZM12 15.4996C10.07 15.4996 8.5 13.9296 8.5 11.9996C8.5 10.0696 10.07 8.49964 12 8.49964C13.93 8.49964 15.5 10.0696 15.5 11.9996C15.5 13.9296 13.93 15.4996 12 15.4996ZM21.868 11.5016C21.229 10.3896 17.706 4.81564 11.729 5.00264C6.202 5.14364 2.986 10.0136 2.132 11.5016C1.956 11.8106 1.956 12.1886 2.132 12.4976C2.762 13.5946 6.162 18.9996 12.025 18.9996C12.106 18.9996 12.188 18.9986 12.271 18.9966C17.798 18.8556 21.014 13.9856 21.868 12.4976C22.044 12.1886 22.044 11.8106 21.868 11.5016Z"
        fill="#F7941E"
      />
      <mask
        id="mask0"
        {...{ 'mask-type': 'alpha' }} // ✅ truyền trực tiếp attribute gốc SVG
        maskUnits="userSpaceOnUse"
        x="2"
        y="4"
        width="20"
        height="15"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 10.4996C11.173 10.4996 10.5 11.1726 10.5 11.9996C10.5 12.8266 11.173 13.4996 12 13.4996C12.827 13.4996 13.5 12.8266 13.5 11.9996C13.5 11.1726 12.827 10.4996 12 10.4996ZM12 15.4996C10.07 15.4996 8.5 13.9296 8.5 11.9996C8.5 10.0696 10.07 8.49964 12 8.49964C13.93 8.49964 15.5 10.0696 15.5 11.9996C15.5 13.9296 13.93 15.4996 12 15.4996ZM21.868 11.5016C21.229 10.3896 17.706 4.81564 11.729 5.00264C6.202 5.14364 2.986 10.0136 2.132 11.5016C1.956 11.8106 1.956 12.1886 2.132 12.4976C2.762 13.5946 6.162 18.9996 12.025 18.9996C12.106 18.9996 12.188 18.9986 12.271 18.9966C17.798 18.8556 21.014 13.9856 21.868 12.4976C22.044 12.1886 22.044 11.8106 21.868 11.5016Z"
          fill="white"
        />
      </mask>
    </svg>
  ),
  download_orange: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0028 12.0759C11.001 12.0508 11 12.0255 11 12V4C11 3.448 11.447 3 12 3C12.553 3 13 3.448 13 4V11.9998L15.4 10.2C15.842 9.867 16.469 9.958 16.8 10.4C17.132 10.842 17.042 11.469 16.6 11.8L12.6 14.8C12.423 14.933 12.211 15 12 15C11.799 15 11.598 14.939 11.425 14.818L7.425 12.004C6.973 11.686 6.864 11.062 7.182 10.611C7.5 10.159 8.123 10.05 8.575 10.368L11.0028 12.0759ZM6 17V18H18V17C18 16.45 18.45 16 19 16C19.55 16 20 16.45 20 17V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V17C4 16.45 4.45 16 5 16C5.55 16 6 16.45 6 17Z"
        fill="#F7941E"
      />
      <mask
        id="mask0"
        {...{ 'mask-type': 'alpha' }} // ✅ truyền trực tiếp attribute gốc SVG
        maskUnits="userSpaceOnUse"
        x="4"
        y="3"
        width="16"
        height="17"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.0028 12.0759C11.001 12.0508 11 12.0255 11 12V4C11 3.448 11.447 3 12 3C12.553 3 13 3.448 13 4V11.9998L15.4 10.2C15.842 9.867 16.469 9.958 16.8 10.4C17.132 10.842 17.042 11.469 16.6 11.8L12.6 14.8C12.423 14.933 12.211 15 12 15C11.799 15 11.598 14.939 11.425 14.818L7.425 12.004C6.973 11.686 6.864 11.062 7.182 10.611C7.5 10.159 8.123 10.05 8.575 10.368L11.0028 12.0759ZM6 17V18H18V17C18 16.45 18.45 16 19 16C19.55 16 20 16.45 20 17V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V17C4 16.45 4.45 16 5 16C5.55 16 6 16.45 6 17Z"
          fill="white"
        />
      </mask>
    </svg>
  ),
  sign_in: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 14H10.375C10.1687 14 10 13.8313 10 13.625V12.375C10 12.1687 10.1687 12 10.375 12H13C13.5531 12 14 11.5531 14 11V5C14 4.44688 13.5531 4 13 4H10.375C10.1687 4 10 3.83125 10 3.625V2.375C10 2.16875 10.1687 2 10.375 2H13C14.6562 2 16 3.34375 16 5V11C16 12.6562 14.6562 14 13 14ZM11.5312 7.71875L6.28125 2.46875C5.8125 2 5 2.32812 5 3V6H0.75C0.334375 6 0 6.33437 0 6.75V9.75C0 10.1656 0.334375 10.5 0.75 10.5H5V13.5C5 14.1719 5.8125 14.5 6.28125 14.0312L11.5312 8.78125C11.8219 8.4875 11.8219 8.0125 11.5312 7.71875Z"
        fill="white"
      />
    </svg>
  ),
  user_login: (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 8C9.20938 8 11 6.20937 11 4C11 1.79063 9.20938 0 7 0C4.79063 0 3 1.79063 3 4C3 6.20937 4.79063 8 7 8ZM9.8 9H9.27812C8.58437 9.31875 7.8125 9.5 7 9.5C6.1875 9.5 5.41875 9.31875 4.72188 9H4.2C1.88125 9 0 10.8813 0 13.2V14.5C0 15.3281 0.671875 16 1.5 16H12.5C13.3281 16 14 15.3281 14 14.5V13.2C14 10.8813 12.1187 9 9.8 9Z"
        fill="#9A9A9A"
      />
    </svg>
  ),
  lock_login: (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 7H11.75V4.75C11.75 2.13125 9.61875 0 7 0C4.38125 0 2.25 2.13125 2.25 4.75V7H1.5C0.671875 7 0 7.67188 0 8.5V14.5C0 15.3281 0.671875 16 1.5 16H12.5C13.3281 16 14 15.3281 14 14.5V8.5C14 7.67188 13.3281 7 12.5 7ZM9.25 7H4.75V4.75C4.75 3.50938 5.75938 2.5 7 2.5C8.24063 2.5 9.25 3.50938 9.25 4.75V7Z"
        fill="#9E9E9E"
      />
    </svg>
  ),
  copy: (
    <svg
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 0H2C0.9 0 0 0.9 0 2V16H2V2H14V0ZM13 4H6C4.9 4 4.01 4.9 4.01 6L4 20C4 21.1 4.89 22 5.99 22H17C18.1 22 19 21.1 19 20V10L13 4ZM6 20V6H12V11H17V20H6Z"
        fill="#0D99FF"
      />
    </svg>
  ),
  addRowAbove: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33464 4.99935H1.66797V16.666C1.66797 17.5827 2.41797 18.3327 3.33464 18.3327H15.0013V16.666H3.33464V4.99935ZM16.668 1.66602H6.66797C5.7513 1.66602 5.0013 2.41602 5.0013 3.33268V13.3327C5.0013 14.2493 5.7513 14.9993 6.66797 14.9993H16.668C17.5846 14.9993 18.3346 14.2493 18.3346 13.3327V3.33268C18.3346 2.41602 17.5846 1.66602 16.668 1.66602ZM16.668 13.3327H6.66797V3.33268H16.668V13.3327ZM10.8346 12.4993H12.5013V9.16602H15.8346V7.49935H12.5013V4.16602H10.8346V7.49935H7.5013V9.16602H10.8346V12.4993Z"
        fill="#A8B1BD"
      />
    </svg>
  ),
  addRowBelow: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6654 15.0007H18.332L18.332 3.33398C18.332 2.41732 17.582 1.66732 16.6654 1.66732H4.9987V3.33398L16.6654 3.33398V15.0007ZM3.33203 18.334L13.332 18.334C14.2487 18.334 14.9987 17.584 14.9987 16.6673L14.9987 6.66732C14.9987 5.75065 14.2487 5.00065 13.332 5.00065L3.33203 5.00065C2.41536 5.00065 1.66536 5.75065 1.66536 6.66732V16.6673C1.66536 17.584 2.41536 18.334 3.33203 18.334ZM3.33203 6.66732L13.332 6.66732L13.332 16.6673H3.33203L3.33203 6.66732ZM9.16536 7.50065H7.4987V10.834L4.16536 10.834L4.16536 12.5007L7.4987 12.5007V15.834H9.16536V12.5007H12.4987V10.834H9.16536V7.50065Z"
        fill="#A8B1BD"
      />
    </svg>
  ),
  import: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.71875 6.40539L10 3.125L13.2812 6.40539"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11.8749V3.1272"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.875 11.875V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  deleteRow: (
    // <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    //   <path
    //     d="M13.3346 7.5V15.8333H6.66797V7.5H13.3346ZM12.0846 2.5H7.91797L7.08464 3.33333H4.16797V5H15.8346V3.33333H12.918L12.0846 2.5ZM15.0013 5.83333H5.0013V15.8333C5.0013 16.75 5.7513 17.5 6.66797 17.5H13.3346C14.2513 17.5 15.0013 16.75 15.0013 15.8333V5.83333Z"
    //     fill="#A8B1BD"
    //   />
    // </svg>

    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8744 4.375L3.12439 4.37501"
        stroke="#FF4648"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.875 1.875H13.125"
        stroke="#FF4648"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.625 4.375V16.25C15.625 16.4158 15.5592 16.5747 15.4419 16.6919C15.3247 16.8092 15.1658 16.875 15 16.875H5C4.83424 16.875 4.67527 16.8092 4.55806 16.6919C4.44085 16.5747 4.375 16.4158 4.375 16.25V4.375"
        stroke="#FF4648"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};
